export type Lang = 'en' | 'zh' | 'ko' | 'ja' | 'es' | 'vi';

export const langNames: Record<Lang, string> = {
  en: 'English',
  zh: '中文',
  ko: '한국어',
  ja: '日本語',
  es: 'Español',
  vi: 'Tiếng Việt',
};

export const translations: Record<Lang, Record<string, string>> = {
  en: {
    // 通用
        // 收藏
    'fav.add': 'Add to Favorites',
    'fav.remove': 'Remove from Favorites',
    'fav.added': 'Added to favorites ❤️',
    'fav.removed': 'Removed from favorites',

    // 优惠券
    'coupon.claim': 'Claim Coupon',
    'coupon.code': 'Enter coupon code',
    'coupon.claimed': 'Coupon claimed! 🎉',
    'coupon.invalid': 'Invalid coupon code',
    'coupon.expired': 'Coupon expired',
    'coupon.discount': 'Off',
    'coupon.minOrder': 'Min. Order',
    // ===== 新增：用户端优惠券 =====
    'coupon.title': 'Coupons',
    'coupon.myCoupons': 'My Coupons',
    'coupon.use': 'Use Now',
    'coupon.used': 'Used',
    'coupon.toUse': 'To Use',
    'coupon.all': 'All',
    'coupon.unavailable': 'No coupons available',
    'coupon.apply': 'Apply Coupon',
    'coupon.enterCode': 'Enter coupon code',
    'coupon.applySuccess': 'Coupon applied!',
    'coupon.select': 'Select Coupon',
    'coupon.validUntil': 'Valid until',
    'coupon.condition': 'Conditions',
    'coupon.range': 'Applicable Range',
    'coupon.amountOff': 'Amount Off',
    'coupon.percentOff': 'Percent Off',
    'coupon.offPrefix': 'Off',
    'coupon.noCoupon': 'Don\'t use coupon',
    'coupon.claimCenter': 'Claim Coupons',
    'coupon.noAvailable': 'No available coupons',
    'coupon.alreadyClaimed': 'Already claimed',
    'coupon.platform': 'Platform',

    // 收货地址
    'addr.name': 'Name',
    'addr.phone': 'Phone',
    'addr.detail': 'Address',
    'addr.default': 'Default',
    'addr.setDefault': 'Set as default',
    'addr.add': 'Add Address',
    'addr.edit': 'Edit Address',
    'addr.delete': 'Delete Address',
    'addr.save': 'Save',

    // 通知
    'notif.title': 'Notifications',
    'notif.readAll': 'Mark all as read',
    'notif.empty': 'No notifications',
    'notif.unread': 'unread',

    // 评价
    'review.title': 'Reviews',
    'review.write': 'Write a Review',
    'review.rating': 'Rating',
    'review.content': 'Your review',
    'review.submit': 'Submit',
    'review.avg': 'Average',
    'review.total': 'reviews',
    'review.submitted': 'Review submitted! ⭐',
    'review.exists': 'You already reviewed this product',
        // 商家入驻
    'merchant.apply': 'Apply as Merchant',
    'merchant.name': 'Store Name',
    'merchant.contact': 'Contact Name',
    'merchant.phone': 'Phone Number *',
    'merchant.desc': 'Store Description',
    'merchant.agree': 'I agree to the Merchant Service Agreement',
    'merchant.submit': 'Submit Application',
    'merchant.status': 'Application Status',
    'merchant.pending': '⏳ Under Review',
    'merchant.approved': '✅ Approved',
    'merchant.rejected': '❌ Rejected',
    'merchant.none': 'Not applied yet',
    'merchant.myStore': 'My Store',
    'merchant.storeName': 'Store Name *',
    'merchant.welcome': 'Welcome, Merchant!',
    'merchant.applySuccess': 'Application submitted! We will review it soon.',
    'merchant.applyFail': 'Failed to submit application',
    'merchant.alreadyApplied': 'You have already applied',
    'merchant.dashboard': 'Merchant Dashboard',
    'merchant.products': 'My Products',
    'merchant.orders': 'Store Orders',
    'merchant.income': 'Income',
    'merchant.comingSoon': 'Merchant features coming soon',

    'merchant.fillRequired': 'Please fill in all required fields',
    'merchant.uploadIdCard': 'Please upload both sides of ID card',
    'merchant.uploadEnterprise': 'Please upload business license and legal person ID',
    'merchant.typeLabel': 'Merchant Type *',
    'merchant.typePersonal': '👤 Individual',
    'merchant.typeEnterprise': '🏢 Enterprise',
    'merchant.countryLabel': 'Country/Region *',
    
    'merchant.contactName': 'Contact Name *',
    'merchant.email': 'Email *',
    'merchant.personalQualification': 'Personal Documents',
    'merchant.idCardFront': 'ID Card Front *',
    'merchant.idCardBack': 'ID Card Back *',
    'merchant.enterpriseQualification': 'Enterprise Documents',
    'merchant.businessLicense': 'Business License *',
    'merchant.legalIdCard': 'Legal Person ID *',
    'merchant.agreement': 'I agree to the Merchant Agreement',
    'merchant.newStore': 'Open New Store',
    'merchant.storeCount': '{current}/{max} stores',
    'merchant.rejectReasonLabel': 'Reason:',
    'merchant.reapply': 'Reapply',
    // ===== 商家优惠券表单（新增）=====
    'tab.coupons': '🎫 Coupons',
    'merchant.coupons': '🎫 My Coupons',
    'merchant.createCoupon': 'Create Coupon',
    'label.code': 'Code',
    'label.discount': 'Discount',
    'label.type': 'Type',
    'label.minOrder': 'Min. Order',
    'label.maxUses': 'Max Uses',
    'label.validUntil': 'Valid Until',
    'label.used': 'Used',
    'label.action': 'Action',
    'coupon.fixed': 'Fixed Amount (π)',
    'coupon.percent': 'Percentage (%)',
    'text.noData': 'No coupons yet',
    'text.unlimited': 'Unlimited',
    'btn.create': 'Create',
    'btn.cancel': 'Cancel',
    'btn.delete': 'Delete',

    // ===== 新增：商家优惠券管理 =====
    'mc.title': 'Coupon Management',
    'mc.create': 'Create Coupon',
    'mc.edit': 'Edit Coupon',
    'mc.delete': 'Delete',
    'mc.name': 'Coupon Name',
    'mc.code': 'Coupon Code',
    'mc.type': 'Coupon Type',
    'mc.amountOff': 'Amount Off',
    'mc.percentOff': 'Percent Off',
    'mc.discountValue': 'Discount Value',
    'mc.minOrderAmount': 'Min. Order Amount',
    'mc.totalQuantity': 'Total Quantity',
    'mc.limitPerUser': 'Limit Per User',
    'mc.startTime': 'Start Time',
    'mc.endTime': 'End Time',
    'mc.active': 'Active',
    'mc.inactive': 'Inactive',
    'mc.createSuccess': 'Coupon created!',
    'mc.updateSuccess': 'Coupon updated!',
    'mc.deleteConfirm': 'Delete this coupon?',
    'mc.noCoupons': 'No coupons yet',

        // 商家商品管理
    'mp.add': 'Add Product',
    'mp.edit': 'Edit Product',
    'mp.delete': 'Delete Product',
    'mp.name': 'Product Name',
    'mp.image': 'Image URL',
    'mp.price': 'Pi Price',
    'mp.originalPrice': 'Original Price ¥',
    'mp.category': 'Category',
    'cat.clothing': 'Clothing & Bags',
    'cat.digital': 'Phones & Digital',
    'cat.appliances': 'Home Appliances',
    'cat.home': 'Home & Garden',
    'cat.beauty': 'Beauty',
    'cat.baby': 'Baby & Toys',
    'cat.food': 'Food',
    'cat.sports': 'Sports',
    'cat.auto': 'Auto',
    'cat.books': 'Books & Entertainment',
    'cat.pets': 'Pets',
    'cat.health': 'Health',
    'cat.garden': 'Garden',
    'cat.industrial': 'Industrial',
    'cat.virtual': 'Virtual',  // ← 注意不是 wirtual
        // Sub-categories - Clothing
    'cat.clothing_women': 'Women',
    'cat.clothing_men': 'Men',
    'cat.clothing_kids': 'Kids',
    'cat.clothing_underwear': 'Underwear',
    'cat.clothing_shoes': 'Shoes',
    'cat.clothing_bags': 'Bags',
    'cat.clothing_accessories': 'Accessories',
    'cat.clothing_jewelry': 'Jewelry',
    'cat.clothing_glasses': 'Glasses',
    'cat.clothing_watches': 'Watches',
    // Sub-categories - Digital
    'cat.digital_phone': 'Mobile Phones',
    'cat.digital_acc': 'Accessories',
    'cat.digital_computer': 'Computers',
    'cat.digital_tablet': 'Tablets',
    'cat.digital_camera': 'Cameras',
    'cat.digital_smart': 'Smart Devices',
    'cat.digital_audio': 'Audio',
    'cat.digital_office': 'Office',
    // Sub-categories - Appliances
    'cat.appliances_major': 'Major Appliances',
    'cat.appliances_kitchen': 'Kitchen',
    'cat.appliances_living': 'Living',
    'cat.appliances_personal': 'Personal Care',
    // Sub-categories - Home
    'cat.home_furniture': 'Furniture',
    'cat.home_textile': 'Textile',
    'cat.home_kitchenware': 'Kitchenware',
    'cat.home_storage': 'Storage',
    'cat.home_decor': 'Decor',
    'cat.home_lighting': 'Lighting',
    'cat.home_bathroom': 'Bathroom',
    'cat.home_materials': 'Materials',
    // Sub-categories - Beauty
    'cat.beauty_skincare': 'Skincare',
    'cat.beauty_makeup': 'Makeup',
    'cat.beauty_perfume': 'Perfume',
    'cat.beauty_hair': 'Hair',
    'cat.beauty_oral': 'Oral Care',
    'cat.beauty_body': 'Body Care',
    'cat.beauty_men': 'Men',
    'cat.beauty_tools': 'Tools',
    // Sub-categories - Baby
    'cat.baby_formula': 'Formula',
    'cat.baby_diapers': 'Diapers',
    'cat.baby_gear': 'Gear',
    'cat.baby_clothing': 'Clothing',
    'cat.baby_toys': 'Toys',
    'cat.baby_maternity': 'Maternity',
    'cat.baby_edu': 'Education',
    // Sub-categories - Food
    'cat.food_snacks': 'Snacks',
    'cat.food_grain': 'Grain',
    'cat.food_drinks': 'Drinks',
    'cat.food_fresh': 'Fresh',
    'cat.food_alcohol': 'Alcohol',
    'cat.food_health': 'Health Food',
    'cat.food_instant': 'Instant',
    // Sub-categories - Sports
    'cat.sports_wear': 'Wear',
    'cat.sports_shoes': 'Shoes',
    'cat.sports_fitness': 'Fitness',
    'cat.sports_outdoor': 'Outdoor',
    'cat.sports_cycling': 'Cycling',
    'cat.sports_balls': 'Balls',
    'cat.sports_swimming': 'Swimming',
    'cat.sports_yoga': 'Yoga',
    // Sub-categories - Auto
    'cat.auto_interior': 'Interior',
    'cat.auto_exterior': 'Exterior',
    'cat.auto_parts': 'Parts',
    'cat.auto_maintenance': 'Maintenance',
    'cat.auto_elec': 'Electronics',
    'cat.auto_tires': 'Tires',
    'cat.auto_tools': 'Tools',
    // Sub-categories - Books
    'cat.books_book': 'Books',
    'cat.books_av': 'AV',
    'cat.books_ebook': 'E-books',
    'cat.books_film': 'Film',
    'cat.books_games': 'Games',
    'cat.books_anime': 'Anime',
    'cat.books_instruments': 'Instruments',
    'cat.books_creative': 'Creative',
    // Sub-categories - Pets
    'cat.pets_food': 'Food',
    'cat.pets_snacks': 'Snacks',
    'cat.pets_toys': 'Toys',
    'cat.pets_beds': 'Beds',
    'cat.pets_wash': 'Wash',
    'cat.pets_med': 'Medical',
    'cat.pets_aquarium': 'Aquarium',
    // Sub-categories - Health
    'cat.health_medicine': 'Medicine',
    'cat.health_devices': 'Devices',
    'cat.health_supplements': 'Supplements',
    'cat.health_equipment': 'Equipment',
    'cat.health_adult': 'Adult',
    'cat.health_tcm': 'TCM',
    // Sub-categories - Garden
    'cat.garden_seeds': 'Seeds',
    'cat.garden_fertilizer': 'Fertilizer',
    'cat.garden_tools': 'Tools',
    'cat.garden_pots': 'Pots',
    'cat.garden_plants': 'Plants',
    'cat.garden_machinery': 'Machinery',
    // Sub-categories - Industrial
    'cat.industrial_hardware': 'Hardware',
    'cat.industrial_electrical': 'Electrical',
    'cat.industrial_safety': 'Safety',
    'cat.industrial_security': 'Security',
    'cat.industrial_packaging': 'Packaging',
    'cat.industrial_consumables': 'Consumables',
    // Sub-categories - Virtual
    'cat.virtual_phone': 'Phone Credit',
    'cat.virtual_game': 'Game Cards',
    'cat.virtual_member': 'Membership',
    'cat.virtual_local': 'Local Life',
    'cat.virtual_housekeeping': 'Housekeeping',
    'cat.virtual_education': 'Education',


    'mp.description': 'Description',
    'mp.stock': 'Stock',
    'mp.published': 'Published',
    'mp.hidden': 'Hidden',
    'mp.myProducts': 'My Products',
    'mp.noProducts': 'No products yet',
    'mp.addSuccess': 'Product added!',
    'mp.updateSuccess': 'Product updated!',
    'mp.deleteConfirm': 'Delete this product?',
    'mp.stockLeft': 'in stock',
    'mp.batchImport': 'Batch Import',
    'mp.csvFormat': 'CSV Format:',
    'mp.downloadTemplate': 'Download Template',
    'mp.preview': 'Preview',
    'mp.showFirst5': 'First 5',
    'mp.totalItems': 'Total',
    'mp.items': 'items',
    'mp.parseSuccess': 'Parse Success',
    'mp.csvEmpty': 'CSV is empty or invalid',
    'mp.importSuccess': 'Import Complete',
    'mp.importFail': 'Import Failed',
    'mp.importing': 'Importing...',
    // 店铺页面
    'store.title': 'Store',
    'store.products': 'All Products',
    'store.noProducts': 'This store has no products yet',
    'store.visit': 'Visit Store',
    'store.loading': 'Loading...',
    'store.merchantNotFound': 'Merchant not found',
    'store.loadFailed': 'Failed to load',
    'store.backHome': 'Back to Home',
    'store.joined': 'Joined',
    'store.allCategories': 'All',
    'store.sold': 'Sold',
    // 商家订单
    'mo.pendingShip': 'Pending Shipment',
    'mo.shipped': 'Shipped',
    'mo.completed': 'Completed',
    'mo.refundPending': 'Refund Pending',
    'mo.noOrders': 'No orders',
    'mo.items': 'items',
    'mo.refundReason': 'Refund reason',
    'mo.tracking': 'Tracking',
    'mo.orderTime': 'Order time',
    'mo.shipTime': 'Ship time',
    'mo.ship': 'Ship',
    'mo.enterTracking': 'Enter tracking number',
    'mo.confirmShip': 'Confirm',
    'mo.confirmComplete': 'Confirm Complete',
    'mo.approveRefund': 'Approve Refund',
    'mo.rejectRefund': 'Reject Refund',
    'mo.approveRefundConfirm': 'Approve this refund?',
    //买家订单
    'bo.viewDetail': 'View Detail',
    'bo.orderDetail': 'Order Detail',
    'bo.stepPaid': 'Paid',
    'bo.stepShipped': 'Shipped',
    'bo.stepCompleted': 'Completed',
    'bo.refundProcessing': 'Refund Processing',
    'bo.refundApproved': 'Refund Approved',
    'bo.refundRejected': 'Refund Rejected',
    'bo.productInfo': 'Product Info',
    'bo.shippingInfo': 'Shipping Info',
    'bo.orderInfo': 'Order Info',
    'bo.completeTime': 'Completed at',
    'bo.requestRefund': 'Request Refund',
    'bo.refundReason': 'Refund Reason',
    'bo.refundReasonPlaceholder': 'Please describe the reason for refund...',
    'bo.submitRefund': 'Submit Refund Request',
    'bo.refundAlreadyRequested': 'Refund already requested',

    // 商家财务
    'finance.title': 'Finance',
    'finance.overview': 'Income Overview',
    'finance.totalEarnings': 'Total Earnings',
    'finance.totalWithdrawn': 'Total Withdrawn',
    'finance.balance': 'Available Balance',
    'finance.pendingSettlements': 'Pending Settlements',
    'finance.pendingWithdrawals': 'Pending Withdrawals',
    'finance.transactions': 'Transaction Details',
    'finance.withdrawals': 'Withdrawal Records',
    'finance.withdraw': 'Withdraw',
    'finance.withdrawAmount': 'Withdrawal Amount',
    'finance.piWallet': 'Pi Wallet Address',
    'finance.withdrawSubmit': 'Submit Withdrawal',
    'finance.withdrawSuccess': 'Withdrawal request submitted!',
    'finance.withdrawFail': 'Withdrawal failed',
    'finance.insufficientBalance': 'Insufficient balance',
    'finance.noTransactions': 'No transactions yet',
    'finance.noWithdrawals': 'No withdrawal records',
    'finance.type': 'Type',
    'finance.amount': 'Amount',
    'finance.commission': 'Commission',
    'finance.netAmount': 'Net Amount',
    'finance.status': 'Status',
    'finance.time': 'Time',
    'finance.settlement': 'Settlement',
    'finance.withdrawal': 'Withdrawal',
    'finance.pendingStatus': 'Pending',
    'finance.completedStatus': 'Completed',
    'finance.rejectedStatus': 'Rejected',

    'stats.title': 'Data Statistics',
    'stats.todaySales': 'Today Sales',
    'stats.weekSales': 'Week Sales',
    'stats.monthSales': 'Month Sales',
    'stats.totalSales': 'Total Sales',
    'stats.orderCount': 'Orders',
    'stats.productCount': 'Products',
    'stats.pendingShip': 'Pending Shipment',
    'stats.refundPending': 'Refund Pending',
    'stats.productRanking': 'Product Ranking',
    'stats.sales': 'Sales',
    'stats.orderNum': 'Orders',
    'stats.noData': 'No data yet',

    'home.hotStores': 'Hot Stores',

    'store.logo': 'Store Logo URL',
    'store.announcement': 'Store Announcement',
    'store.businessHours': 'Business Hours',
    'store.open': 'Open',
    'store.closed': 'Closed',
    'store.update': 'Update Store',
    'store.updated': 'Store updated!',
    'store.preview': 'Preview Store',

    'app.name': '314PiMall',
    'loading': 'Loading...',
    'cancel': 'Cancel',
    'confirm': 'Confirm',
    'delete': 'Delete',
    'edit': 'Edit',
    'save': 'Save',
    'close': 'Close',
    'success': 'Success',
    'failed': 'Failed',
    'search': 'Search Product',
    'noResults': 'No products found for',
    'copy': 'Copy All',
    'copied': 'Copied!',

    // 底部导航
    'nav.home': 'Home',
    'nav.class': 'Class',
    'nav.cart': 'Cart',
    'nav.mine': 'Mine',

    // 首页
    'home.banner.title': '🛍️ 314PiMall Multi-merchant Platform',
    'home.banner.desc': 'Discover thousands of products from trusted Pi merchants',
    'home.seckill': '⚡ Seckill',
    'home.recommend': '🔥 Recommend',
    'home.more': 'More ›',
    'home.results': 'Results',
    'home.filterBy': 'Category',
    'home.clearFilter': 'Clear',    

    // 商品详情
    'detail.title': 'Product Detail',
    'detail.addCart': 'Add to Cart',
    'detail.buyNow': 'Buy Now',
    'detail.description': 'Description',
    'detail.sold': 'sold',

    // 购物车
    'cart.title': '🛒 Cart',
    'cart.empty': 'Cart is empty',
    'cart.emptyDesc': 'Go shopping now!',
    'cart.total': 'Total:',
    'cart.checkout': 'Checkout',
    'cart.processing': 'Processing...',
    'cart.added': 'added to cart! 🛒',

    // 支付
    'pay.success': 'Payment successful! 🎉',
    'pay.failed': 'Payment failed, please try again',
    'pay.openPi': 'Please open in Pi Browser',

    // 我的
    'mine.user': 'Pi User',
    'mine.signIn': 'Sign in to view your profile',
    'mine.signOut': 'Sign out',
    'mine.pending': 'Pending',
    'mine.shipping': 'Shipping',
    'mine.completed': 'Completed',
    'mine.returns': 'Returns',
    'mine.orders': 'My Orders',
    'mine.wallet': 'Pi Wallet',
    'mine.coupons': 'My Coupons',
    'mine.address': 'Shipping Address',
    'mine.favorites': 'Favorites',
    'mine.history': 'Transaction History',
    'mine.settings': 'Settings',
    'mine.service': 'Customer Service',
    'mine.noOrders': 'No orders yet',
    'mine.noTx': 'No transactions yet',
    'mine.walletDesc': 'Please check your Pi Wallet in the Pi Browser',
    'mine.noCoupons': 'No coupons available',
    'mine.noAddress': 'No address saved',
    'mine.noFavorites': 'No favorites yet',
    'mine.comingSoon': 'Coming soon',
    'mine.orderNum': 'Order',
    'mine.payment': 'Payment',

    // 订单状态
    'order.refunded': '💸 Refunded',
    'order.cancelled': '❌ Cancelled',
    'order.completed': '✅ Completed',
    'order.pending': '⏳ Pending',

    // 语言
    'lang.title': 'Language',
        // 商家财务
    'mf.balance': 'Available Balance',
    'mf.totalEarnings': 'Total Earnings',
    'mf.totalWithdrawn': 'Total Withdrawn',
    'mf.pendingSettlement': 'Pending Settlement',
    'mf.requestWithdrawal': 'Request Withdrawal',
    'mf.transactions': 'Transaction History',
    'mf.noTransactions': 'No transactions yet',
    'mf.settlement': 'Settlement',
    'mf.withdrawal': 'Withdrawal',
    'mf.commission': 'Commission',
    'mf.net': 'Net',
    'mf.completed': 'Completed',
    'mf.rejected': 'Rejected',
    'mf.pendingReview': 'Pending Review',
    'mf.withdrawAmount': 'Withdrawal Amount (π)',
    'mf.piWalletAddress': 'Pi Wallet Address',
    'mf.walletPlaceholder': 'Enter your Pi wallet address',
    'mf.walletRequired': 'Pi wallet address is required',
    'mf.invalidAmount': 'Please enter a valid amount',
    'mf.submitWithdrawal': 'Submit Withdrawal',
    'mf.withdrawSubmitted': 'Withdrawal request submitted! ⏳',
    'mf.withdrawalHistory': 'Withdrawal History',
    'mf.noWithdrawals': 'No withdrawal records',
    'mf.availableBalance': 'Available Balance',

  },
  zh: {
    'fav.add': '添加收藏',
    'fav.remove': '取消收藏',
    'fav.added': '已添加收藏 ❤️',
    'fav.removed': '已取消收藏',

    'coupon.claim': '领取优惠券',
    'coupon.code': '输入优惠券码',
    'coupon.claimed': '优惠券领取成功！🎉',
    'coupon.invalid': '无效的优惠券码',
    'coupon.expired': '优惠券已过期',
    'coupon.discount': '折',
    'coupon.minOrder': '最低消费',
    // ===== 新增：用户端优惠券 =====
    'coupon.title': '优惠券',
    'coupon.myCoupons': '我的优惠券',
    'coupon.use': '立即使用',
    'coupon.used': '已使用',
    'coupon.toUse': '待使用',
    'coupon.all': '全部',
    'coupon.unavailable': '暂无可用优惠券',
    'coupon.apply': '使用优惠券',
    'coupon.enterCode': '请输入优惠码',
    'coupon.applySuccess': '优惠券已应用',
    'coupon.select': '选择优惠券',
    'coupon.validUntil': '有效期至',
    'coupon.condition': '使用条件',
    'coupon.range': '适用范围',
    'coupon.amountOff': '满减',
    'coupon.percentOff': '折扣',
    'coupon.offPrefix': '减',
    'coupon.noCoupon': '不使用优惠券',
    'coupon.claimCenter': '领券中心',      // zh
    'coupon.noAvailable': '暂无可领取的优惠券', // zh
    'coupon.alreadyClaimed': '您已领取过该券',  // zh
    'coupon.platform': '平台券',         // zh


    'addr.name': '姓名',
    'addr.phone': '电话',
    'addr.detail': '详细地址',
    'addr.default': '默认',
    'addr.setDefault': '设为默认',
    'addr.add': '新增地址',
    'addr.edit': '编辑地址',
    'addr.delete': '删除地址',
    'addr.save': '保存',

    'notif.title': '通知',
    'notif.readAll': '全部已读',
    'notif.empty': '暂无通知',
    'notif.unread': '未读',

    'review.title': '评价',
    'review.write': '写评价',
    'review.rating': '评分',
    'review.content': '评价内容',
    'review.submit': '提交',
    'review.avg': '平均',
    'review.total': '条评价',
    'review.submitted': '评价提交成功！⭐',
    'review.exists': '您已评价过该商品',
    //商家入驻
    'merchant.apply': '申请入驻',
    'merchant.name': '店铺名称',
    'merchant.contact': '联系人',
    'merchant.phone': '联系电话',
    'merchant.desc': '店铺简介',
    'merchant.agree': '我同意商家服务协议',
    'merchant.submit': '提交申请',
    'merchant.status': '申请状态',
    'merchant.pending': '⏳ 审核中',
    'merchant.approved': '✅ 已通过',
    'merchant.rejected': '❌ 已拒绝',
    'merchant.none': '暂未申请',
    'merchant.myStore': '我的店铺',
    'merchant.storeName': '店铺名称',
    'merchant.welcome': '欢迎，商家！',
    'merchant.applySuccess': '申请已提交！我们将尽快审核。',
    'merchant.applyFail': '申请提交失败',
    'merchant.alreadyApplied': '您已提交过申请',
    'merchant.dashboard': '商家中心',
    'merchant.products': '我的商品',
    'merchant.orders': '店铺订单',
    'merchant.income': '收入',
    'merchant.comingSoon': '商家功能即将上线',

    'merchant.fillRequired': '请填写所有必填项',
    'merchant.uploadIdCard': '请上传身份证正反面',
    'merchant.uploadEnterprise': '请上传营业执照和法人身份证',
    'merchant.typeLabel': '商家类型 *',
    'merchant.typePersonal': '👤 个人商家',
    'merchant.typeEnterprise': '🏢 企业商家',
    'merchant.countryLabel': '国家/地区 *',

    'merchant.contactName': '联系人姓名 *',
    'merchant.email': '邮箱 *',
    
    'merchant.personalQualification': '个人资质',
    'merchant.idCardFront': '身份证人像面 *',
    'merchant.idCardBack': '身份证国徽面 *',
    'merchant.enterpriseQualification': '企业资质',
    'merchant.businessLicense': '营业执照 *',
    'merchant.legalIdCard': '法人身份证 *',
    'merchant.agreement': '我已阅读并同意《商家入驻协议》',
    'merchant.newStore': '开设新店铺',
    'merchant.storeCount': '已开{current}/{max}家',
    'merchant.rejectReasonLabel': '拒绝原因：',
    'merchant.reapply': '重新申请',
    // ===== 商家优惠券表单（新增）=====
    'tab.coupons': '🎫 优惠券',
    'merchant.coupons': '🎫 我的优惠券',
    'merchant.createCoupon': '创建优惠券',
    'label.code': '券码',
    'label.discount': '优惠金额',
    'label.type': '类型',
    'label.minOrder': '最低消费',
    'label.maxUses': '最大使用次数',
    'label.validUntil': '有效期至',
    'label.used': '已使用',
    'label.action': '操作',
    'coupon.fixed': '固定金额 (π)',
    'coupon.percent': '百分比 (%)',
    'text.noData': '暂无优惠券',
    'text.unlimited': '不限',
    'btn.create': '创建',
    'btn.cancel': '取消',
    'btn.delete': '删除',

    // ===== 新增：商家优惠券管理 =====
    'mc.title': '优惠券管理',
    'mc.create': '创建优惠券',
    'mc.edit': '编辑优惠券',
    'mc.delete': '删除',
    'mc.name': '优惠券名称',
    'mc.code': '优惠码',
    'mc.type': '优惠券类型',
    'mc.amountOff': '满减券',
    'mc.percentOff': '折扣券',
    'mc.discountValue': '优惠面值',
    'mc.minOrderAmount': '最低消费金额',
    'mc.totalQuantity': '发放总量',
    'mc.limitPerUser': '每人限领',
    'mc.startTime': '开始时间',
    'mc.endTime': '结束时间',
    'mc.active': '进行中',
    'mc.inactive': '已结束',
    'mc.createSuccess': '优惠券创建成功！',
    'mc.updateSuccess': '优惠券更新成功！',
    'mc.deleteConfirm': '确定删除该优惠券？',
    'mc.noCoupons': '暂无优惠券',

    'mp.add': '添加商品',

    'mp.edit': '编辑商品',
    'mp.delete': '删除商品',
    'mp.name': '商品名称',
    'mp.image': '图片URL',
    'mp.imageTip': '可将图片上传至图床后粘贴链接，支持 https:// 格式',
    'mp.price': 'Pi价格',
    'mp.originalPrice': '原价 ¥',
    'mp.category': '分类',
    'cat.clothing': '服饰鞋包',
    'cat.digital': '手机数码',
    'cat.appliances': '家用电器',
    'cat.home': '家居家装',
    'cat.beauty': '美妆个护',
    'cat.baby': '母婴玩具',
    'cat.food': '食品生鲜',
    'cat.sports': '运动户外',
    'cat.auto': '汽车用品',
    'cat.books': '图书文娱',
    'cat.pets': '宠物用品',
    'cat.health': '医药健康',
    'cat.garden': '农资园艺',
    'cat.industrial': '工业品/工具',
    'cat.virtual': '虚拟/服务',  // ← 注意不是 wirtual
        // 子分类 - 服饰鞋包
    'cat.clothing_women': '女装',
    'cat.clothing_men': '男装',
    'cat.clothing_kids': '童装/童鞋',
    'cat.clothing_underwear': '内衣/家居服',
    'cat.clothing_shoes': '鞋靴',
    'cat.clothing_bags': '箱包',
    'cat.clothing_accessories': '服饰配件/饰品',
    'cat.clothing_jewelry': '珠宝首饰',
    'cat.clothing_glasses': '眼镜',
    'cat.clothing_watches': '手表',
    // 子分类 - 手机数码
    'cat.digital_phone': '手机',
    'cat.digital_acc': '手机配件',
    'cat.digital_computer': '电脑/笔记本',
    'cat.digital_tablet': '平板',
    'cat.digital_camera': '相机/摄像机',
    'cat.digital_smart': '智能设备',
    'cat.digital_audio': '影音数码',
    'cat.digital_office': '办公设备',
    // 子分类 - 家用电器
    'cat.appliances_major': '大家电',
    'cat.appliances_kitchen': '厨卫电器',
    'cat.appliances_living': '生活电器',
    'cat.appliances_personal': '个护电器',
    // 子分类 - 家居家装
    'cat.home_furniture': '家具',
    'cat.home_textile': '家纺',
    'cat.home_kitchenware': '厨具/餐具',
    'cat.home_storage': '收纳清洁',
    'cat.home_decor': '家居饰品',
    'cat.home_lighting': '灯具',
    'cat.home_bathroom': '卫浴',
    'cat.home_materials': '家装主材',
    // 子分类 - 美妆个护
    'cat.beauty_skincare': '护肤',
    'cat.beauty_makeup': '彩妆',
    'cat.beauty_perfume': '香水',
    'cat.beauty_hair': '美发',
    'cat.beauty_oral': '口腔护理',
    'cat.beauty_body': '身体护理',
    'cat.beauty_men': '男士护理',
    'cat.beauty_tools': '美容工具',
    // 子分类 - 母婴玩具
    'cat.baby_formula': '奶粉/辅食',
    'cat.baby_diapers': '尿裤湿巾',
    'cat.baby_gear': '婴童用品',
    'cat.baby_clothing': '童装童鞋',
    'cat.baby_toys': '玩具',
    'cat.baby_maternity': '孕产用品',
    'cat.baby_edu': '早教/乐器',
    // 子分类 - 食品生鲜
    'cat.food_snacks': '休闲零食',
    'cat.food_grain': '粮油调味',
    'cat.food_drinks': '饮料/乳品',
    'cat.food_fresh': '生鲜',
    'cat.food_alcohol': '酒水',
    'cat.food_health': '滋补保健',
    'cat.food_instant': '方便速食',
    // 子分类 - 运动户外
    'cat.sports_wear': '运动服饰',
    'cat.sports_shoes': '运动鞋',
    'cat.sports_fitness': '健身器材',
    'cat.sports_outdoor': '户外装备',
    'cat.sports_cycling': '骑行装备',
    'cat.sports_balls': '球类',
    'cat.sports_swimming': '游泳用品',
    'cat.sports_yoga': '瑜伽/舞蹈',
    // 子分类 - 汽车用品
    'cat.auto_interior': '汽车内饰',
    'cat.auto_exterior': '汽车外饰',
    'cat.auto_parts': '车品配件',
    'cat.auto_maintenance': '保养/清洁',
    'cat.auto_elec': '车载电器',
    'cat.auto_tires': '轮胎/轮毂',
    'cat.auto_tools': '维修工具',
    // 子分类 - 图书文娱
    'cat.books_book': '图书',
    'cat.books_av': '音像',
    'cat.books_ebook': '电子书',
    'cat.books_film': '影视',
    'cat.books_games': '游戏',
    'cat.books_anime': '动漫',
    'cat.books_instruments': '乐器',
    'cat.books_creative': '文创周边',
    // 子分类 - 宠物用品
    'cat.pets_food': '宠物食品',
    'cat.pets_snacks': '宠物零食',
    'cat.pets_toys': '宠物玩具',
    'cat.pets_beds': '宠物窝笼',
    'cat.pets_wash': '宠物洗护',
    'cat.pets_med': '宠物医疗',
    'cat.pets_aquarium': '水族用品',
    // 子分类 - 医药健康
    'cat.health_medicine': '药品',
    'cat.health_devices': '医疗器械',
    'cat.health_supplements': '保健品',
    'cat.health_equipment': '健康器械',
    'cat.health_adult': '成人用品',
    'cat.health_tcm': '中医养生',
    // 子分类 - 农资园艺
    'cat.garden_seeds': '种子/种苗',
    'cat.garden_fertilizer': '农药/肥料',
    'cat.garden_tools': '园艺工具',
    'cat.garden_pots': '花盆/花土',
    'cat.garden_plants': '绿植/花卉',
    'cat.garden_machinery': '农用机械',
    // 子分类 - 工业品/工具
    'cat.industrial_hardware': '五金工具',
    'cat.industrial_electrical': '电工电气',
    'cat.industrial_safety': '劳保用品',
    'cat.industrial_security': '安防设备',
    'cat.industrial_packaging': '包装材料',
    'cat.industrial_consumables': '工业耗材',
    // 子分类 - 虚拟/服务
    'cat.virtual_phone': '话费充值',
    'cat.virtual_game': '游戏点卡',
    'cat.virtual_member': '会员订阅',
    'cat.virtual_local': '本地生活',
    'cat.virtual_housekeeping': '家政服务',
    'cat.virtual_education': '教育课程',


    'mp.description': '商品描述',
    'mp.stock': '库存',
    'mp.published': '已上架',
    'mp.hidden': '已下架',
    'mp.myProducts': '我的商品',
    'mp.noProducts': '暂无商品',
    'mp.addSuccess': '商品添加成功！',
    'mp.updateSuccess': '商品更新成功！',
    'mp.deleteConfirm': '确认删除该商品？',
    'mp.stockLeft': '库存',
    'mp.batchImport': '批量导入',
    'mp.csvFormat': 'CSV格式要求：',
    'mp.downloadTemplate': '下载模板',
    'mp.preview': '数据预览',
    'mp.showFirst5': '前5条',
    'mp.totalItems': '共',
    'mp.items': '条',
    'mp.parseSuccess': '解析成功',
    'mp.csvEmpty': 'CSV文件为空或格式错误',
    'mp.importSuccess': '导入完成',
    'mp.importFail': '导入失败',
    'mp.importing': '导入中...',
    'store.title': '店铺',
    'store.products': '全部商品',
    'store.noProducts': '该店铺暂无商品',
    'store.visit': '进入店铺',
    'store.loading': '加载中...',
    'store.merchantNotFound': '商家不存在',
    'store.loadFailed': '加载失败',
    'store.backHome': '返回首页',
    'store.joined': '入驻于',
    'store.allCategories': '全部',
    'store.sold': '已售',
    // 商家订单
    'mo.pendingShip': '待发货',
    'mo.shipped': '已发货',
    'mo.completed': '已完成',
    'mo.refundPending': '退款中',
    'mo.noOrders': '暂无订单',
    'mo.items': '件',
    'mo.refundReason': '退款原因',
    'mo.tracking': '物流单号',
    'mo.orderTime': '下单时间',
    'mo.shipTime': '发货时间',
    'mo.ship': '发货',
    'mo.enterTracking': '输入物流单号',
    'mo.confirmShip': '确认发货',
    'mo.confirmComplete': '确认完成',
    'mo.approveRefund': '同意退款',
    'mo.rejectRefund': '拒绝退款',
    'mo.approveRefundConfirm': '确认同意退款？',
    //买家订单
    'bo.viewDetail': '查看详情',
    'bo.orderDetail': '订单详情',
    'bo.stepPaid': '已付款',
    'bo.stepShipped': '已发货',
    'bo.stepCompleted': '已完成',
    'bo.refundProcessing': '退款处理中',
    'bo.refundApproved': '退款已通过',
    'bo.refundRejected': '退款已拒绝',
    'bo.productInfo': '商品信息',
    'bo.shippingInfo': '物流信息',
    'bo.orderInfo': '订单信息',
    'bo.completeTime': '完成时间',
    'bo.requestRefund': '申请退款',
    'bo.refundReason': '退款原因',
    'bo.refundReasonPlaceholder': '请描述退款原因...',
    'bo.submitRefund': '提交退款申请',
    'bo.refundAlreadyRequested': '已申请退款',

    // 商家财务
    'finance.title': '财务',
    'finance.overview': '收入概览',
    'finance.totalEarnings': '总收入',
    'finance.totalWithdrawn': '已提现',
    'finance.balance': '可用余额',
    'finance.pendingSettlements': '待结算',
    'finance.pendingWithdrawals': '待提现',
    'finance.transactions': '交易明细',
    'finance.withdrawals': '提现记录',
    'finance.withdraw': '提现',
    'finance.withdrawAmount': '提现金额',
    'finance.piWallet': 'Pi钱包地址',
    'finance.withdrawSubmit': '提交提现',
    'finance.withdrawSuccess': '提现申请已提交！',
    'finance.withdrawFail': '提现失败',
    'finance.insufficientBalance': '余额不足',
    'finance.noTransactions': '暂无交易记录',
    'finance.noWithdrawals': '暂无提现记录',
    'finance.type': '类型',
    'finance.amount': '金额',
    'finance.commission': '佣金',
    'finance.netAmount': '净收入',
    'finance.status': '状态',
    'finance.time': '时间',
    'finance.settlement': '结算',
    'finance.withdrawal': '提现',
    'finance.pendingStatus': '待处理',
    'finance.completedStatus': '已完成',
    'finance.rejectedStatus': '已拒绝',

    'stats.title': '数据统计',
    'stats.todaySales': '今日销售额',
    'stats.weekSales': '本周销售额',
    'stats.monthSales': '本月销售额',
    'stats.totalSales': '总销售额',
    'stats.orderCount': '订单数',
    'stats.productCount': '商品数',
    'stats.pendingShip': '待发货',
    'stats.refundPending': '退款中',
    'stats.productRanking': '商品排行',
    'stats.sales': '销量',
    'stats.orderNum': '订单',
    'stats.noData': '暂无数据',
    'home.hotStores': '热门店铺',

    'store.logo': '店铺Logo链接',
    'store.announcement': '店铺公告',
    'store.businessHours': '营业状态',
    'store.open': '营业中',
    'store.closed': '休息中',
    'store.update': '更新店铺',
    'store.updated': '店铺更新成功！',
    'store.preview': '预览店铺',

    'app.name': '314PiMall',
    'loading': '加载中...',
    'cancel': '取消',
    'confirm': '确认',
    'delete': '删除',
    'edit': '编辑',
    'save': '保存',
    'close': '关闭',
    'success': '成功',
    'failed': '失败',
    'search': '搜索商品',
    'noResults': '未找到相关商品',
    'copy': '复制全部',
    'copied': '已复制！',
    'nav.home': '首页',
    'nav.class': '分类',
    'nav.cart': '购物车',
    'nav.mine': '我的',
    'home.banner.title': '🛍️ 314PiMall 多商家平台',
    'home.banner.desc': '发现优质Pi商家好物',
    'home.seckill': '⚡ 秒杀',
    'home.recommend': '🔥 推荐',
    'home.more': '更多 ›',
    'home.results': '搜索结果',
    'home.filterBy': '分类',
    'home.clearFilter': '清除', 
    
    'detail.title': '商品详情',
    'detail.addCart': '加入购物车',
    'detail.buyNow': '立即购买',
    'detail.description': '商品描述',
    'detail.sold': '已售',
    'cart.title': '🛒 购物车',
    'cart.empty': '购物车是空的',
    'cart.emptyDesc': '快去选购吧！',
    'cart.total': '合计：',
    'cart.checkout': '结算',
    'cart.processing': '处理中...',
    'cart.added': '已加入购物车！🛒',
    'pay.success': '支付成功！🎉',
    'pay.failed': '支付失败，请重试',
    'pay.openPi': '请在Pi浏览器中打开',
    'mine.user': 'Pi用户',
    'mine.signIn': '登录查看个人资料',
    'mine.signOut': '退出登录',
    'mine.pending': '待付款',
    'mine.shipping': '待发货',
    'mine.completed': '已完成',
    'mine.returns': '退换货',
    'mine.orders': '我的订单',
    'mine.wallet': 'Pi钱包',
    'mine.coupons': '我的优惠券',
    'mine.address': '收货地址',
    'mine.favorites': '我的收藏',
    'mine.history': '交易记录',
    'mine.settings': '设置',
    'mine.service': '客服',
    'mine.noOrders': '暂无订单',
    'mine.noTx': '暂无交易记录',
    'mine.walletDesc': '请在Pi浏览器中查看Pi钱包',
    'mine.noCoupons': '暂无优惠券',
    'mine.noAddress': '暂无收货地址',
    'mine.noFavorites': '暂无收藏',
    'mine.comingSoon': '即将上线',
    'mine.orderNum': '订单',
    'mine.payment': '支付',
    'order.refunded': '💸 已退款',
    'order.cancelled': '❌ 已取消',
    'order.completed': '✅ 已完成',
    'order.pending': '⏳ 待付款',
    'lang.title': '语言',
        // 商家财务
    'mf.title': '商家财务',
    'mf.balance': '可用余额',
    'mf.totalEarnings': '累计收入',
    'mf.totalWithdrawn': '已提现',
    'mf.pendingSettlement': '待结算',
    'mf.requestWithdrawal': '申请提现',
    'mf.transactions': '交易明细',
    'mf.noTransactions': '暂无交易记录',
    'mf.settlement': '结算',
    'mf.withdrawal': '提现',
    'mf.commission': '佣金',
    'mf.net': '净收入',
    'mf.completed': '已完成',
    'mf.rejected': '已拒绝',
    'mf.pendingReview': '审核中',
    'mf.withdrawAmount': '提现金额 (π)',
    'mf.piWalletAddress': 'Pi钱包地址',
    'mf.walletPlaceholder': '请输入Pi钱包地址',
    'mf.walletRequired': '请输入Pi钱包地址',
    'mf.invalidAmount': '请输入有效金额',
    'mf.submitWithdrawal': '提交提现',
    'mf.withdrawSubmitted': '提现申请已提交！⏳',
    'mf.withdrawalHistory': '提现记录',
    'mf.noWithdrawals': '暂无提现记录',
    'mf.availableBalance': '可用余额',

  },
  ko: {
    'fav.add': '찜 추가',
    'fav.remove': '찜 삭제',
    'fav.added': '찜에 추가됨 ❤️',
    'fav.removed': '찜에서 삭제됨',

        // 优惠券
    'coupon.claim': '쿠폰 받기',
    'coupon.code': '쿠폰 코드 입력',
    'coupon.claimed': '쿠폰을 받았습니다! 🎉',
    'coupon.invalid': '유효하지 않은 쿠폰 코드',
    'coupon.expired': '쿠폰이 만료되었습니다',
    'coupon.discount': '할인',
    'coupon.minOrder': '최소 주문금액',
    // ===== 新增：用户端优惠券 =====
    'coupon.title': '쿠폰',
    'coupon.myCoupons': '내 쿠폰',
    'coupon.use': '지금 사용',
    'coupon.used': '사용완료',
    'coupon.toUse': '사용가능',
    'coupon.all': '전체',
    'coupon.unavailable': '사용 가능한 쿠폰이 없습니다',
    'coupon.apply': '쿠폰 적용',
    'coupon.enterCode': '쿠폰 코드를 입력하세요',
    'coupon.applySuccess': '쿠폰이 적용되었습니다',
    'coupon.select': '쿠폰 선택',
    'coupon.validUntil': '유효기간',
    'coupon.condition': '사용조건',
    'coupon.range': '적용범위',
    'coupon.amountOff': '정액할인',
    'coupon.percentOff': '할인율',
    'coupon.offPrefix': '할인',
    'coupon.noCoupon': '쿠폰 사용 안 함',
    'coupon.claimCenter': '쿠폰 받기',
    'coupon.noAvailable': '받을 수 있는 쿠폰이 없습니다',
    'coupon.alreadyClaimed': '이미 받은 쿠폰입니다',
    'coupon.platform': '플랫폼 쿠폰',


    // 收货地址
    'addr.name': '이름',
    'addr.phone': '전화번호',
    'addr.detail': '주소',
    'addr.default': '기본',
    'addr.setDefault': '기본으로 설정',
    'addr.add': '주소 추가',
    'addr.edit': '주소 수정',
    'addr.delete': '주소 삭제',
    'addr.save': '저장',

    'notif.title': '알림',
    'notif.readAll': '모두 읽음',
    'notif.empty': '알림 없음',
    'notif.unread': '안읽음',

    'review.title': '리뷰',
    'review.write': '리뷰 작성',
    'review.rating': '평점',
    'review.content': '리뷰 내용',
    'review.submit': '제출',
    'review.avg': '평균',
    'review.total': '개의 리뷰',
    'review.submitted': '리뷰가 제출되었습니다! ⭐',
    'review.exists': '이미 리뷰를 작성했습니다',
    //商家入驻
        // 商家入驻
    'merchant.apply': '입점 신청',
    'merchant.name': '스토어 이름',
    'merchant.contact': '담당자',
    'merchant.phone': '연락처 *',
    'merchant.desc': '스토어 소개',
    'merchant.agree': '판매자 서비스 이용약관에 동의합니다',
    'merchant.submit': '신청 제출',
    'merchant.status': '신청 상태',
    'merchant.pending': '⏳ 검토 중',
    'merchant.approved': '✅ 승인됨',
    'merchant.rejected': '❌ 거부됨',
    'merchant.none': '미신청',
    'merchant.myStore': '내 스토어',
    'merchant.storeName': '스토어 이름 *',
    'merchant.welcome': '환영합니다, 판매자님!',
    'merchant.applySuccess': '신청이 제출되었습니다! 곧 검토하겠습니다.',
    'merchant.applyFail': '신청 제출 실패',
    'merchant.alreadyApplied': '이미 신청하셨습니다',
    'merchant.dashboard': '판매자 센터',
    'merchant.products': '내 상품',
    'merchant.orders': '스토어 주문',
    'merchant.income': '수입',
    'merchant.comingSoon': '판매자 기능이 곧 출시됩니다',
    'merchant.fillRequired': '필수 항목을 모두 입력해주세요',
    'merchant.uploadIdCard': '신분증 앞뒤면을 업로드해주세요',
    'merchant.uploadEnterprise': '사업자등록증과 법인 신분증을 업로드해주세요',
    'merchant.typeLabel': '판매자 유형 *',
    'merchant.typePersonal': '👤 개인 판매자',
    'merchant.typeEnterprise': '🏢 기업 판매자',
    'merchant.countryLabel': '국가/지역 *',
    'merchant.contactName': '담당자 이름 *',
    'merchant.email': '이메일 *',
    'merchant.personalQualification': '개인 자격',
    'merchant.idCardFront': '신분증 앞면 *',
    'merchant.idCardBack': '신분증 뒷면 *',
    'merchant.enterpriseQualification': '기업 자격',
    'merchant.businessLicense': '사업자등록증 *',
    'merchant.legalIdCard': '법인 신분증 *',
    'merchant.agreement': '판매자 입점 약관에 동의합니다',
    'merchant.newStore': '새 스토어 열기',
    'merchant.storeCount': '已开{current}/{max}家',
    'merchant.rejectReasonLabel': '거부 사유:',
    'merchant.reapply': '재신청',
    // ===== 商家优惠券表单（新增）=====
    'tab.coupons': '🎫 쿠폰',
    'merchant.coupons': '🎫 내 쿠폰',
    'merchant.createCoupon': '쿠폰 생성',
    'label.code': '코드',
    'label.discount': '할인금액',
    'label.type': '유형',
    'label.minOrder': '최소주문금액',
    'label.maxUses': '최대사용횟수',
    'label.validUntil': '유효기간',
    'label.used': '사용완료',
    'label.action': '작업',
    'coupon.fixed': '정액 (π)',
    'coupon.percent': '할인율 (%)',
    'text.noData': '쿠폰이 없습니다',
    'text.unlimited': '무제한',
    'btn.create': '생성',
    'btn.cancel': '취소',
    'btn.delete': '삭제',

    // ===== 新增：商家优惠券管理 =====
    'mc.title': '쿠폰 관리',
    'mc.create': '쿠폰 생성',
    'mc.edit': '쿠폰 수정',
    'mc.delete': '삭제',
    'mc.name': '쿠폰명',
    'mc.code': '쿠폰 코드',
    'mc.type': '쿠폰 종류',
    'mc.amountOff': '정액할인',
    'mc.percentOff': '할인율',
    'mc.discountValue': '할인금액',
    'mc.minOrderAmount': '최소주문금액',
    'mc.totalQuantity': '총 발행수량',
    'mc.limitPerUser': '1인당 제한',
    'mc.startTime': '시작일',
    'mc.endTime': '종료일',
    'mc.active': '진행중',
    'mc.inactive': '종료됨',
    'mc.createSuccess': '쿠폰이 생성되었습니다',
    'mc.updateSuccess': '쿠폰이 수정되었습니다',
    'mc.deleteConfirm': '해당 쿠폰을 삭제하시겠습니까?',
    'mc.noCoupons': '쿠폰이 없습니다',

    'mp.add': '상품 추가',
    'mp.edit': '상품 수정',
    'mp.delete': '상품 삭제',
    'mp.name': '상품명',
    'mp.image': '이미지 URL',
    'mp.price': 'Pi 가격',
    'mp.originalPrice': '원가 ¥',
    'mp.category': '카테고리',
    'cat.clothing': '의류/신발/가방',
    'cat.digital': '휴대폰/디지털',
    'cat.appliances': '가전제품',
    'cat.home': '가구/인테리어',
    'cat.beauty': '뷰티/케어',
    'cat.baby': '유아/완구',
    'cat.food': '식품/신선식품',
    'cat.sports': '스포츠/아웃도어',
    'cat.auto': '자동차용품',
    'cat.books': '도서/엔터테인먼트',
    'cat.pets': '반려동물용품',
    'cat.health': '의약/건강',
    'cat.garden': '농자재/원예',
    'cat.industrial': '산업용품/공구',
    'cat.virtual': '가상/서비스',
        // 服饰鞋包子类
    'cat.clothing_women': '여성복',
    'cat.clothing_men': '남성복',
    'cat.clothing_kids': '아동복/아동화',
    'cat.clothing_underwear': '속옷/홈웨어',
    'cat.clothing_shoes': '구두/신발',
    'cat.clothing_bags': '가방',
    'cat.clothing_accessories': '패션잡화/액세서리',
    'cat.clothing_jewelry': '보석/주얼리',
    'cat.clothing_glasses': '안경',
    'cat.clothing_watches': '시계',
    // 手机数码子类
    'cat.digital_phone': '휴대폰',
    'cat.digital_acc': '휴대폰 액세서리',
    'cat.digital_computer': '컴퓨터/노트북',
    'cat.digital_tablet': '태블릿',
    'cat.digital_camera': '카메라/캠코더',
    'cat.digital_smart': '스마트 기기',
    'cat.digital_audio': '오디오/영상',
    'cat.digital_office': '사무기기',
    // 家用电器子类
    'cat.appliances_major': '대형가전',
    'cat.appliances_kitchen': '주방가전',
    'cat.appliances_living': '생활가전',
    'cat.appliances_personal': '미용가전',
    // 家居家装子类
    'cat.home_furniture': '가구',
    'cat.home_textile': '홈텍스타일',
    'cat.home_kitchenware': '조리기구/식기',
    'cat.home_storage': '수납/청소',
    'cat.home_decor': '인테리어 소품',
    'cat.home_lighting': '조명',
    'cat.home_bathroom': '욕실',
    'cat.home_materials': '인테리어 자재',
    // 美妆个护子类
    'cat.beauty_skincare': '스킨케어',
    'cat.beauty_makeup': '메이크업',
    'cat.beauty_perfume': '향수',
    'cat.beauty_hair': '헤어',
    'cat.beauty_oral': '구강케어',
    'cat.beauty_body': '바디케어',
    'cat.beauty_men': '남성케어',
    'cat.beauty_tools': '뷰티도구',
    // 母婴玩具子类
    'cat.baby_formula': '분유/이유식',
    'cat.baby_diapers': '기저귀/물티슈',
    'cat.baby_gear': '유아용품',
    'cat.baby_clothing': '유아동복',
    'cat.baby_toys': '장난감',
    'cat.baby_maternity': '임산부용품',
    'cat.baby_edu': '조기교육/악기',
    // 食品生鲜子类
    'cat.food_snacks': '과자/스낵',
    'cat.food_grain': '곡물/조미료',
    'cat.food_drinks': '음료/유제품',
    'cat.food_fresh': '신선식품',
    'cat.food_alcohol': '주류',
    'cat.food_health': '건강식품',
    'cat.food_instant': '즉석식품',
    // 运动户外子类
    'cat.sports_wear': '스포츠웨어',
    'cat.sports_shoes': '운동화',
    'cat.sports_fitness': '피트니스기구',
    'cat.sports_outdoor': '아웃도어장비',
    'cat.sports_cycling': '자전거장비',
    'cat.sports_balls': '구기',
    'cat.sports_swimming': '수영용품',
    'cat.sports_yoga': '요가/댄스',
    // 汽车用品子类
    'cat.auto_interior': '차량내장',
    'cat.auto_exterior': '차량외장',
    'cat.auto_parts': '차량부품',
    'cat.auto_maintenance': '정비/세차',
    'cat.auto_elec': '차량용전자기기',
    'cat.auto_tires': '타이어/휠',
    'cat.auto_tools': '공구',
    // 图书文娱子类
    'cat.books_book': '도서',
    'cat.books_av': '음반/영상',
    'cat.books_ebook': '전자책',
    'cat.books_film': '영화',
    'cat.books_games': '게임',
    'cat.books_anime': '애니메이션',
    'cat.books_instruments': '악기',
    'cat.books_creative': '문구/굿즈',
    // 宠物用品子类
    'cat.pets_food': '펫사료',
    'cat.pets_snacks': '펫간식',
    'cat.pets_toys': '펫장난감',
    'cat.pets_beds': '펫하우스',
    'cat.pets_wash': '펫목욕',
    'cat.pets_med': '펫의료',
    'cat.pets_aquarium': '수족관용품',
    // 医药健康子类
    'cat.health_medicine': '의약품',
    'cat.health_devices': '의료기기',
    'cat.health_supplements': '건강보조식품',
    'cat.health_equipment': '건강기구',
    'cat.health_adult': '성인용품',
    'cat.health_tcm': '한방/양생',
    // 农资园艺子类
    'cat.garden_seeds': '씨앗/묘목',
    'cat.garden_fertilizer': '농약/비료',
    'cat.garden_tools': '원예도구',
    'cat.garden_pots': '화분/화훼용토',
    'cat.garden_plants': '식물/꽃',
    'cat.garden_machinery': '농기계',
    // 工业品/工具子类
    'cat.industrial_hardware': '공구/철물',
    'cat.industrial_electrical': '전기/전자',
    'cat.industrial_safety': '안전용품',
    'cat.industrial_security': '보안장비',
    'cat.industrial_packaging': '포장재',
    'cat.industrial_consumables': '산업소모품',
    // 虚拟/服务子类
    'cat.virtual_phone': '휴대폰충전',
    'cat.virtual_game': '게임카드',
    'cat.virtual_member': '멤버십',
    'cat.virtual_local': '로컬라이프',
    'cat.virtual_housekeeping': '가사도우미',
    'cat.virtual_education': '교육과정',

    'mp.description': '상품 설명',
    'mp.stock': '재고',
    'mp.published': '판매 중',
    'mp.hidden': '숨김',
    'mp.myProducts': '내 상품',
    'mp.noProducts': '상품 없음',
    'mp.addSuccess': '상품이 추가되었습니다!',
    'mp.updateSuccess': '상품이 수정되었습니다!',
    'mp.deleteConfirm': '이 상품을 삭제하시겠습니까?',
    'mp.stockLeft': '재고',
    'store.title': '스토어',
    'store.products': '전체 상품',
    'store.noProducts': '이 스토어에는 상품이 없습니다',
    'store.visit': '스토어 방문',
    'store.loading': '로딩 중...',
    'store.merchantNotFound': '판매자를 찾을 수 없습니다',
    'store.loadFailed': '로드 실패',
    'store.backHome': '홈으로 돌아가기',
    'store.joined': '가입일',
    'store.allCategories': '전체',
    'store.sold': '판매됨',
    // 商家订单
    'mo.pendingShip': '배송 대기',
    'mo.shipped': '배송 중',
    'mo.completed': '완료',
    'mo.refundPending': '환불 대기',
    'mo.noOrders': '주문 없음',
    'mo.items': '개',
    'mo.refundReason': '환불 사유',
    'mo.tracking': '송장번호',
    'mo.orderTime': '주문 시간',
    'mo.shipTime': '배송 시간',
    'mo.ship': '배송',
    'mo.enterTracking': '송장번호 입력',
    'mo.confirmShip': '확인',
    'mo.confirmComplete': '완료 확인',
    'mo.approveRefund': '환불 승인',
    'mo.rejectRefund': '환불 거부',
    'mo.approveRefundConfirm': '환불을 승인하시겠습니까?',
    //买家订单
    'bo.viewDetail': '상세 보기',
    'bo.orderDetail': '주문 상세',
    'bo.stepPaid': '결제 완료',
    'bo.stepShipped': '배송 완료',
    'bo.stepCompleted': '주문 완료',
    'bo.refundProcessing': '환불 처리 중',
    'bo.refundApproved': '환불 승인됨',
    'bo.refundRejected': '환불 거부됨',
    'bo.productInfo': '상품 정보',
    'bo.shippingInfo': '배송 정보',
    'bo.orderInfo': '주문 정보',
    'bo.completeTime': '완료 시간',
    'bo.requestRefund': '환불 요청',
    'bo.refundReason': '환불 사유',
    'bo.refundReasonPlaceholder': '환불 사유를 입력해주세요...',
    'bo.submitRefund': '환불 요청 제출',
    'bo.refundAlreadyRequested': '이미 환불 요청됨',
     // 商家财务
    'finance.title': '재무',
    'finance.overview': '수입 개요',
    'finance.totalEarnings': '총 수입',
    'finance.totalWithdrawn': '총 출금',
    'finance.balance': '사용 가능 잔액',
    'finance.pendingSettlements': '정산 대기',
    'finance.pendingWithdrawals': '출금 대기',
    'finance.transactions': '거래 내역',
    'finance.withdrawals': '출금 기록',
    'finance.withdraw': '출금',
    'finance.withdrawAmount': '출금 금액',
    'finance.piWallet': 'Pi 지갑 주소',
    'finance.withdrawSubmit': '출금 신청',
    'finance.withdrawSuccess': '출금 신청이 완료되었습니다!',
    'finance.withdrawFail': '출금 실패',
    'finance.insufficientBalance': '잔액 부족',
    'finance.noTransactions': '거래 내역 없음',
    'finance.noWithdrawals': '출금 기록 없음',
    'finance.type': '유형',
    'finance.amount': '금액',
    'finance.commission': '수수료',
    'finance.netAmount': '순수입',
    'finance.status': '상태',
    'finance.time': '시간',
    'finance.settlement': '정산',
    'finance.withdrawal': '출금',
    'finance.pendingStatus': '대기 중',
    'finance.completedStatus': '완료',
    'finance.rejectedStatus': '거부됨',

    'stats.title': '데이터 통계', 'stats.todaySales': '오늘 매출', 'stats.weekSales': '이번 주 매출', 'stats.monthSales': '이번 달 매출', 'stats.totalSales': '총 매출', 'stats.orderCount': '주문 수', 'stats.productCount': '상품 수', 'stats.pendingShip': '배송 대기', 'stats.refundPending': '환불 대기', 'stats.productRanking': '상품 랭킹', 'stats.sales': '판매', 'stats.orderNum': '주문', 'stats.noData': '데이터 없음',

    'app.name': '314PiMall',
    'loading': '로딩 중...',
    'cancel': '취소',
    'confirm': '확인',
    'delete': '삭제',
    'edit': '편집',
    'save': '저장',
    'close': '닫기',
    'success': '성공',
    'failed': '실패',
    'search': '상품 검색',
    'noResults': '검색 결과 없음',
    'copy': '모두 복사',
    'copied': '복사됨!',
    'nav.home': '홈',
    'nav.class': '카테고리',
    'nav.cart': '장바구니',
    'nav.mine': '마이페이지',
    'home.banner.title': '🛍️ 314PiMall 다중 판매자 플랫폼',
    'home.banner.desc': '신뢰할 수 있는 Pi 판매자의 수천 개 상품을 발견하세요',
    'home.seckill': '⚡ 타임세일',
    'home.recommend': '🔥 추천',
    'home.more': '더보기 ›',
    'home.results': '검색 결과',
    'detail.title': '상품 상세',
    'detail.addCart': '장바구니 담기',
    'detail.buyNow': '바로 구매',
    'detail.description': '상품 설명',
    'detail.sold': '판매완료',
    'cart.title': '🛒 장바구니',
    'cart.empty': '장바구니가 비어 있습니다',
    'cart.emptyDesc': '쇼핑을 시작하세요!',
    'cart.total': '합계:',
    'cart.checkout': '결제하기',
    'cart.processing': '처리 중...',
    'cart.added': '장바구니에 추가됨! 🛒',
    'pay.success': '결제 성공! 🎉',
    'pay.failed': '결제 실패, 다시 시도해 주세요',
    'pay.openPi': 'Pi 브라우저에서 열어주세요',
    'mine.user': 'Pi 사용자',
    'mine.signIn': '로그인하여 프로필 보기',
    'mine.signOut': '로그아웃',
    'mine.pending': '결제 대기',
    'mine.shipping': '배송 중',
    'mine.completed': '완료',
    'mine.returns': '반품',
    'mine.orders': '주문 내역',
    'mine.wallet': 'Pi 지갑',
    'mine.coupons': '쿠폰',
    'mine.address': '배송지',
    'mine.favorites': '찜',
    'mine.history': '거래 내역',
    'mine.settings': '설정',
    'mine.service': '고객센터',
    'mine.noOrders': '주문 내역 없음',
    'mine.noTx': '거래 내역 없음',
    'mine.walletDesc': 'Pi 브라우저에서 Pi 지갑을 확인하세요',
    'mine.noCoupons': '쿠폰 없음',
    'mine.noAddress': '배송지 없음',
    'mine.noFavorites': '찜 없음',
    'mine.comingSoon': '준비 중',
    'mine.orderNum': '주문',
    'mine.payment': '결제',
    'order.refunded': '💸 환불됨',
    'order.cancelled': '❌ 취소됨',
    'order.completed': '✅ 완료됨',
    'order.pending': '⏳ 대기 중',
    'lang.title': '언어',
        // 판매자 재무
    'mf.title': '판매자 재무',
    'mf.balance': '사용 가능 잔액',
    'mf.totalEarnings': '총 수입',
    'mf.totalWithdrawn': '출금 완료',
    'mf.pendingSettlement': '정산 대기',
    'mf.requestWithdrawal': '출금 신청',
    'mf.transactions': '거래 내역',
    'mf.noTransactions': '거래 내역 없음',
    'mf.settlement': '정산',
    'mf.withdrawal': '출금',
    'mf.commission': '수수료',
    'mf.net': '순수입',
    'mf.completed': '완료',
    'mf.rejected': '거부',
    'mf.pendingReview': '검토 중',
    'mf.withdrawAmount': '출금 금액 (π)',
    'mf.piWalletAddress': 'Pi 지갑 주소',
    'mf.walletPlaceholder': 'Pi 지갑 주소를 입력하세요',
    'mf.walletRequired': 'Pi 지갑 주소를 입력해주세요',
    'mf.invalidAmount': '유효한 금액을 입력해주세요',
    'mf.submitWithdrawal': '출금 신청',
    'mf.withdrawSubmitted': '출금 신청이 완료되었습니다! ⏳',
    'mf.withdrawalHistory': '출금 내역',
    'mf.noWithdrawals': '출금 내역 없음',
    'mf.availableBalance': '사용 가능 잔액',

  },
  ja: {
    'fav.add': 'お気に入りに追加',
    'fav.remove': 'お気に入りから削除',
    'fav.added': 'お気に入りに追加しました ❤️',
    'fav.removed': 'お気に入りから削除しました',

        // 优惠券
    'coupon.claim': 'クーポンを受け取る',
    'coupon.code': 'クーポンコードを入力',
    'coupon.claimed': 'クーポンを受け取りました！🎉',
    'coupon.invalid': '無効なクーポンコード',
    'coupon.expired': 'クーポンの有効期限が切れました',
    'coupon.discount': '引',
    'coupon.minOrder': '最低注文額',
    // ===== 新增：用户端优惠券 =====
    'coupon.title': 'クーポン',
    'coupon.myCoupons': 'マイクーポン',
    'coupon.use': '今すぐ使う',
    'coupon.used': '使用済み',
    'coupon.toUse': '未使用',
    'coupon.all': 'すべて',
    'coupon.unavailable': '利用可能なクーポンがありません',
    'coupon.apply': 'クーポンを適用',
    'coupon.enterCode': 'クーポンコードを入力',
    'coupon.applySuccess': 'クーポンを適用しました',
    'coupon.select': 'クーポンを選択',
    'coupon.validUntil': '有効期限',
    'coupon.condition': '利用条件',
    'coupon.range': '適用範囲',
    'coupon.amountOff': '定額割引',
    'coupon.percentOff': '割引率',
    'coupon.offPrefix': '割引',
    'coupon.noCoupon': 'クーポンを使用しない',
    'coupon.claimCenter': 'クーポンセンター',
    'coupon.noAvailable': '利用可能なクーポンはありません',
    'coupon.alreadyClaimed': '既に受け取り済みです',
    'coupon.platform': 'プラットフォームクーポン',


    // 收货地址
    'addr.name': '名前',
    'addr.phone': '電話番号',
    'addr.detail': '住所',
    'addr.default': 'デフォルト',
    'addr.setDefault': 'デフォルトに設定',
    'addr.add': '住所追加',
    'addr.edit': '住所編集',
    'addr.delete': '住所削除',
    'addr.save': '保存',

    'notif.title': '通知',
    'notif.readAll': 'すべて既読',
    'notif.empty': '通知なし',
    'notif.unread': '未読',

    'review.title': 'レビュー',
    'review.write': 'レビューを書く',
    'review.rating': '評価',
    'review.content': 'レビュー内容',
    'review.submit': '投稿',
    'review.avg': '平均',
    'review.total': '件のレビュー',
    'review.submitted': 'レビューを投稿しました！⭐',
    'review.exists': 'すでにレビュー済みです',
        // 商家入驻
    'merchant.apply': '出店申請',
    'merchant.name': '店舗名',
    'merchant.contact': '担当者',
    'merchant.phone': '電話番号 *',
    'merchant.desc': '店舗概要',
    'merchant.agree': '販売者サービス規約に同意します',
    'merchant.submit': '申請を提出',
    'merchant.status': '申請状況',
    'merchant.pending': '⏳ 審査中',
    'merchant.approved': '✅ 承認済み',
    'merchant.rejected': '❌ 拒否',
    'merchant.none': '未申請',
    'merchant.myStore': 'マイストア',
    'merchant.storeName': '店舗名 *',
    'merchant.welcome': 'ようこそ、販売者様！',
    'merchant.applySuccess': '申請を提出しました！審査までしばらくお待ちください。',
    'merchant.applyFail': '申請の提出に失敗しました',
    'merchant.alreadyApplied': 'すでに申請済みです',
    'merchant.dashboard': '販売者ダッシュボード',
    'merchant.products': '商品管理',
    'merchant.orders': '店舗注文',
    'merchant.income': '収入',
    'merchant.comingSoon': '販売者機能は近日公開予定',
    'merchant.fillRequired': '必須項目をすべて入力してください',
    'merchant.uploadIdCard': '身分証明書の表裏をアップロードしてください',
    'merchant.uploadEnterprise': '営業許可証と法人身分証明書をアップロードしてください',
    'merchant.typeLabel': '販売者タイプ *',
    'merchant.typePersonal': '👤 個人販売者',
    'merchant.typeEnterprise': '🏢 企業販売者',
    'merchant.countryLabel': '国/地域 *',
    'merchant.contactName': '担当者名 *',
    'merchant.email': 'メールアドレス *',
    'merchant.personalQualification': '個人書類',
    'merchant.idCardFront': '身分証明書（表） *',
    'merchant.idCardBack': '身分証明書（裏） *',
    'merchant.enterpriseQualification': '企業書類',
    'merchant.businessLicense': '営業許可証 *',
    'merchant.legalIdCard': '法人身分証明書 *',
    'merchant.agreement': '販売者出店規約に同意します',
    'merchant.newStore': '新規出店',
    'merchant.storeCount': '已开{current}/{max}家',
    'merchant.rejectReasonLabel': '拒否理由：',
    'merchant.reapply': '再申請',
    // ===== 商家优惠券表单（新增）=====
    'tab.coupons': '🎫 クーポン',
    'merchant.coupons': '🎫 マイクーポン',
    'merchant.createCoupon': 'クーポン作成',
    'label.code': 'コード',
    'label.discount': '割引額',
    'label.type': '種別',
    'label.minOrder': '最低注文額',
    'label.maxUses': '最大使用回数',
    'label.validUntil': '有効期限',
    'label.used': '使用済み',
    'label.action': '操作',
    'coupon.fixed': '定額 (π)',
    'coupon.percent': '割引率 (%)',
    'text.noData': 'クーポンはありません',
    'text.unlimited': '無制限',
    'btn.create': '作成',
    'btn.cancel': 'キャンセル',
    'btn.delete': '削除',

      // ===== 新增：商家优惠券管理 =====
    'mc.title': 'クーポン管理',
    'mc.create': 'クーポン作成',
    'mc.edit': 'クーポン編集',
    'mc.delete': '削除',
    'mc.name': 'クーポン名',
    'mc.code': 'クーポンコード',
    'mc.type': 'クーポン種別',
    'mc.amountOff': '定額割引',
    'mc.percentOff': '割引率',
    'mc.discountValue': '割引額',
    'mc.minOrderAmount': '最低注文金額',
    'mc.totalQuantity': '総発行数',
    'mc.limitPerUser': 'お一人様上限',
    'mc.startTime': '開始日時',
    'mc.endTime': '終了日時',
    'mc.active': '実施中',
    'mc.inactive': '終了',
    'mc.createSuccess': 'クーポンを作成しました',
    'mc.updateSuccess': 'クーポンを更新しました',
    'mc.deleteConfirm': 'このクーポンを削除しますか？',
    'mc.noCoupons': 'クーポンはありません',

    'mp.add': '商品を追加',
    'mp.edit': '商品を編集',
    'mp.delete': '商品を削除',
    'mp.name': '商品名',
    'mp.image': '画像URL',
    'mp.price': 'Pi価格',
    'mp.originalPrice': '原価 ¥',
    'mp.category': 'カテゴリ',
    'cat.clothing': 'ファッション/靴/バッグ',
    'cat.digital': 'スマホ/デジタル',
    'cat.appliances': '家電',
    'cat.home': '家具/インテリア',
    'cat.beauty': '美容/コスメ',
    'cat.baby': 'ベビー/おもちゃ',
    'cat.food': '食品/生鮮',
    'cat.sports': 'スポーツ/アウトドア',
    'cat.auto': 'カー用品',
    'cat.books': '本/エンタメ',
    'cat.pets': 'ペット用品',
    'cat.health': '医薬/健康',
    'cat.garden': '農資材/園芸',
    'cat.industrial': '工業品/工具',
    'cat.virtual': 'バーチャル/サービス',
        // 服饰鞋包子类
    'cat.clothing_women': 'レディース',
    'cat.clothing_men': 'メンズ',
    'cat.clothing_kids': 'キッズ',
    'cat.clothing_underwear': '下着/ルームウェア',
    'cat.clothing_shoes': '靴',
    'cat.clothing_bags': 'バッグ',
    'cat.clothing_accessories': 'ファッション小物',
    'cat.clothing_jewelry': 'ジュエリー',
    'cat.clothing_glasses': 'メガネ',
    'cat.clothing_watches': '時計',
    // 手机数码子类
    'cat.digital_phone': 'スマートフォン',
    'cat.digital_acc': 'スマホアクセサリー',
    'cat.digital_computer': 'パソコン/ノート',
    'cat.digital_tablet': 'タブレット',
    'cat.digital_camera': 'カメラ/ビデオ',
    'cat.digital_smart': 'スマートデバイス',
    'cat.digital_audio': 'オーディオ',
    'cat.digital_office': 'オフィス機器',
    // 家用电器子类
    'cat.appliances_major': '大型家電',
    'cat.appliances_kitchen': 'キッチン家電',
    'cat.appliances_living': '生活家電',
    'cat.appliances_personal': '美容家電',
    // 家居家装子类
    'cat.home_furniture': '家具',
    'cat.home_textile': '布団/タオル',
    'cat.home_kitchenware': 'キッチン用品',
    'cat.home_storage': '収納/掃除',
    'cat.home_decor': 'インテリア',
    'cat.home_lighting': '照明',
    'cat.home_bathroom': 'バス/トイレ',
    'cat.home_materials': '建材',
    // 美妆个护子类
    'cat.beauty_skincare': 'スキンケア',
    'cat.beauty_makeup': 'メイクアップ',
    'cat.beauty_perfume': '香水',
    'cat.beauty_hair': 'ヘアケア',
    'cat.beauty_oral': 'オーラルケア',
    'cat.beauty_body': 'ボディケア',
    'cat.beauty_men': 'メンズケア',
    'cat.beauty_tools': '美容器具',
    // 母婴玩具子类
    'cat.baby_formula': 'ミルク/離乳食',
    'cat.baby_diapers': 'おむつ/ティッシュ',
    'cat.baby_gear': 'ベビー用品',
    'cat.baby_clothing': 'ベビー服',
    'cat.baby_toys': 'おもちゃ',
    'cat.baby_maternity': 'マタニティ',
    'cat.baby_edu': '知育/楽器',
    // 食品生鲜子类
    'cat.food_snacks': 'お菓子/スナック',
    'cat.food_grain': '米/調味料',
    'cat.food_drinks': '飲料/乳製品',
    'cat.food_fresh': '生鮮食品',
    'cat.food_alcohol': 'お酒',
    'cat.food_health': '健康食品',
    'cat.food_instant': 'レトルト/インスタント',
    // 运动户外子类
    'cat.sports_wear': 'スポーツウェア',
    'cat.sports_shoes': 'スポーツシューズ',
    'cat.sports_fitness': 'フィットネス',
    'cat.sports_outdoor': 'アウトドア',
    'cat.sports_cycling': 'サイクリング',
    'cat.sports_balls': 'ボール',
    'cat.sports_swimming': '水泳',
    'cat.sports_yoga': 'ヨガ/ダンス',
    // 汽车用品子类
    'cat.auto_interior': 'カーインテリア',
    'cat.auto_exterior': 'カーエクステリア',
    'cat.auto_parts': 'カーパーツ',
    'cat.auto_maintenance': 'カーメンテナンス',
    'cat.auto_elec': 'カー電子機器',
    'cat.auto_tires': 'タイヤ/ホイール',
    'cat.auto_tools': '工具',
    // 图书文娱子类
    'cat.books_book': '書籍',
    'cat.books_av': 'CD/DVD',
    'cat.books_ebook': '電子書籍',
    'cat.books_film': '映画',
    'cat.books_games': 'ゲーム',
    'cat.books_anime': 'アニメ',
    'cat.books_instruments': '楽器',
    'cat.books_creative': '文房具/グッズ',
    // 宠物用品子类
    'cat.pets_food': 'ペットフード',
    'cat.pets_snacks': 'ペットおやつ',
    'cat.pets_toys': 'ペットおもちゃ',
    'cat.pets_beds': 'ペットハウス',
    'cat.pets_wash': 'ペットシャンプー',
    'cat.pets_med': 'ペット医療',
    'cat.pets_aquarium': 'アクアリウム',
    // 医药健康子类
    'cat.health_medicine': '医薬品',
    'cat.health_devices': '医療機器',
    'cat.health_supplements': 'サプリメント',
    'cat.health_equipment': '健康器具',
    'cat.health_adult': 'アダルト',
    'cat.health_tcm': '漢方/養生',
    // 农资园艺子类
    'cat.garden_seeds': '種/苗',
    'cat.garden_fertilizer': '農薬/肥料',
    'cat.garden_tools': '園芸工具',
    'cat.garden_pots': '鉢/培養土',
    'cat.garden_plants': '植物/花',
    'cat.garden_machinery': '農業機械',
    // 工业品/工具子类
    'cat.industrial_hardware': '金物/工具',
    'cat.industrial_electrical': '電気/電子',
    'cat.industrial_safety': '安全用品',
    'cat.industrial_security': '防犯機器',
    'cat.industrial_packaging': '包装材料',
    'cat.industrial_consumables': '工業用消耗品',
    // 虚拟/服务子类
    'cat.virtual_phone': '携帯チャージ',
    'cat.virtual_game': 'ゲームカード',
    'cat.virtual_member': '会員',
    'cat.virtual_local': 'ローカルライフ',
    'cat.virtual_housekeeping': '家事代行',
    'cat.virtual_education': '教育講座',

    'mp.description': '商品説明',
    'mp.stock': '在庫',
    'mp.published': '出品中',
    'mp.hidden': '非表示',
    'mp.myProducts': '出品商品',
    'mp.noProducts': '商品なし',
    'mp.addSuccess': '商品を追加しました！',
    'mp.updateSuccess': '商品を更新しました！',
    'mp.deleteConfirm': 'この商品を削除しますか？',
    'mp.stockLeft': '在庫',
    'store.title': 'ストア',
    'store.products': '全商品',
    'store.noProducts': 'このストアには商品がありません',
    'store.visit': 'ストアを見る',
    'store.loading': '読み込み中...',
    'store.merchantNotFound': '店舗が見つかりません',
    'store.loadFailed': '読み込み失敗',
    'store.backHome': 'ホームに戻る',
    'store.joined': '入店日',
    'store.allCategories': 'すべて',
    'store.sold': '販売済み',
    // 商家订单
    'mo.pendingShip': '発送待ち',
    'mo.shipped': '発送済み',
    'mo.completed': '完了',
    'mo.refundPending': '返金待ち',
    'mo.noOrders': '注文なし',
    'mo.items': '点',
    'mo.refundReason': '返金理由',
    'mo.tracking': '追跡番号',
    'mo.orderTime': '注文時間',
    'mo.shipTime': '発送時間',
    'mo.ship': '発送',
    'mo.enterTracking': '追跡番号を入力',
    'mo.confirmShip': '確認',
    'mo.confirmComplete': '完了確認',
    'mo.approveRefund': '返金承認',
    'mo.rejectRefund': '返金拒否',
    'mo.approveRefundConfirm': '返金を承認しますか？',
    //买家订单
    'bo.viewDetail': '詳細を見る',
    'bo.orderDetail': '注文詳細',
    'bo.stepPaid': '支払済み',
    'bo.stepShipped': '発送済み',
    'bo.stepCompleted': '完了',
    'bo.refundProcessing': '返金処理中',
    'bo.refundApproved': '返金承認済み',
    'bo.refundRejected': '返金拒否',
    'bo.productInfo': '商品情報',
    'bo.shippingInfo': '配送情報',
    'bo.orderInfo': '注文情報',
    'bo.completeTime': '完了日時',
    'bo.requestRefund': '返金リクエスト',
    'bo.refundReason': '返金理由',
    'bo.refundReasonPlaceholder': '返金理由を入力してください...',
    'bo.submitRefund': '返金リクエスト送信',
    'bo.refundAlreadyRequested': '返金リクエスト済み',
    // 商家财务
    'finance.title': '財務',
    'finance.overview': '収入概要',
    'finance.totalEarnings': '総収入',
    'finance.totalWithdrawn': '出金済み',
    'finance.balance': '利用可能残高',
    'finance.pendingSettlements': '精算待ち',
    'finance.pendingWithdrawals': '出金待ち',
    'finance.transactions': '取引明細',
    'finance.withdrawals': '出金記録',
    'finance.withdraw': '出金',
    'finance.withdrawAmount': '出金額',
    'finance.piWallet': 'Piウォレットアドレス',
    'finance.withdrawSubmit': '出金申請',
    'finance.withdrawSuccess': '出金申請が送信されました！',
    'finance.withdrawFail': '出金失敗',
    'finance.insufficientBalance': '残高不足',
    'finance.noTransactions': '取引記録なし',
    'finance.noWithdrawals': '出金記録なし',
    'finance.type': '種類',
    'finance.amount': '金額',
    'finance.commission': '手数料',
    'finance.netAmount': '純収入',
    'finance.status': '状態',
    'finance.time': '時間',
    'finance.settlement': '精算',
    'finance.withdrawal': '出金',
    'finance.pendingStatus': '待機中',
    'finance.completedStatus': '完了',
    'finance.rejectedStatus': '拒否',

    'stats.title': 'データ統計', 'stats.todaySales': '今日の売上', 'stats.weekSales': '今週の売上', 'stats.monthSales': '今月の売上', 'stats.totalSales': '総売上', 'stats.orderCount': '注文数', 'stats.productCount': '商品数', 'stats.pendingShip': '発送待ち', 'stats.refundPending': '返金待ち', 'stats.productRanking': '商品ランキング', 'stats.sales': '販売', 'stats.orderNum': '注文', 'stats.noData': 'データなし',

    'app.name': '314PiMall',
    'loading': '読み込み中...',
    'cancel': 'キャンセル',
    'confirm': '確認',
    'delete': '削除',
    'edit': '編集',
    'save': '保存',
    'close': '閉じる',
    'success': '成功',
    'failed': '失敗',
    'search': '商品検索',
    'noResults': '検索結果なし',
    'copy': 'すべてコピー',
    'copied': 'コピーしました！',
    'nav.home': 'ホーム',
    'nav.class': 'カテゴリ',
    'nav.cart': 'カート',
    'nav.mine': 'マイページ',
    'home.banner.title': '🛍️ 314PiMall マルチマーチャントプラットフォーム',
    'home.banner.desc': '信頼できるPiマーチャントから数千の商品を発見',
    'home.seckill': '⚡ タイムセール',
    'home.recommend': '🔥 おすすめ',
    'home.more': 'もっと見る ›',
    'home.results': '検索結果',
    'detail.title': '商品詳細',
    'detail.addCart': 'カートに追加',
    'detail.buyNow': '今すぐ購入',
    'detail.description': '商品説明',
    'detail.sold': '販売済み',
    'cart.title': '🛒 カート',
    'cart.empty': 'カートは空です',
    'cart.emptyDesc': 'お買い物を始めましょう！',
    'cart.total': '合計：',
    'cart.checkout': 'チェックアウト',
    'cart.processing': '処理中...',
    'cart.added': 'カートに追加しました！🛒',
    'pay.success': '支払い成功！🎉',
    'pay.failed': '支払いに失敗しました。もう一度お試しください',
    'pay.openPi': 'Piブラウザで開いてください',
    'mine.user': 'Piユーザー',
    'mine.signIn': 'ログインしてプロフィールを表示',
    'mine.signOut': 'ログアウト',
    'mine.pending': '支払い待ち',
    'mine.shipping': '発送中',
    'mine.completed': '完了',
    'mine.returns': '返品',
    'mine.orders': '注文履歴',
    'mine.wallet': 'Piウォレット',
    'mine.coupons': 'クーポン',
    'mine.address': '配送先',
    'mine.favorites': 'お気に入り',
    'mine.history': '取引履歴',
    'mine.settings': '設定',
    'mine.service': 'カスタマーサポート',
    'mine.noOrders': '注文履歴なし',
    'mine.noTx': '取引履歴なし',
    'mine.walletDesc': 'PiブラウザでPiウォレットを確認してください',
    'mine.noCoupons': 'クーポンなし',
    'mine.noAddress': '配送先なし',
    'mine.noFavorites': 'お気に入りなし',
    'mine.comingSoon': '準備中',
    'mine.orderNum': '注文',
    'mine.payment': '支払い',
    'order.refunded': '💸 返金済み',
    'order.cancelled': '❌ キャンセル',
    'order.completed': '✅ 完了',
    'order.pending': '⏳ 待機中',
    'lang.title': '言語',
        // 出品者財務
    'mf.title': '出品者財務',
    'mf.balance': '利用可能残高',
    'mf.totalEarnings': '累計収入',
    'mf.totalWithdrawn': '出金済み',
    'mf.pendingSettlement': '精算待ち',
    'mf.requestWithdrawal': '出金申請',
    'mf.transactions': '取引履歴',
    'mf.noTransactions': '取引履歴なし',
    'mf.settlement': '精算',
    'mf.withdrawal': '出金',
    'mf.commission': '手数料',
    'mf.net': '純収入',
    'mf.completed': '完了',
    'mf.rejected': '拒否',
    'mf.pendingReview': '審査中',
    'mf.withdrawAmount': '出金額 (π)',
    'mf.piWalletAddress': 'Piウォレットアドレス',
    'mf.walletPlaceholder': 'Piウォレットアドレスを入力',
    'mf.walletRequired': 'Piウォレットアドレスを入力してください',
    'mf.invalidAmount': '有効な金額を入力してください',
    'mf.submitWithdrawal': '出金申請',
    'mf.withdrawSubmitted': '出金申請が送信されました！⏳',
    'mf.withdrawalHistory': '出金履歴',
    'mf.noWithdrawals': '出金履歴なし',
    'mf.availableBalance': '利用可能残高',

  },
  es: {
    'fav.add': 'Añadir a favoritos',
    'fav.remove': 'Quitar de favoritos',
    'fav.added': 'Añadido a favoritos ❤️',
    'fav.removed': 'Eliminado de favoritos',

        // 优惠券
    'coupon.claim': 'Reclamar Cupón',
    'coupon.code': 'Ingresar código de cupón',
    'coupon.claimed': '¡Cupón reclamado! 🎉',
    'coupon.invalid': 'Código de cupón inválido',
    'coupon.expired': 'Cupón expirado',
    'coupon.discount': 'Dto.',
    'coupon.minOrder': 'Compra Mín.',
    // ===== 新增：用户端优惠券 =====
    'coupon.title': 'Cupones',
    'coupon.myCoupons': 'Mis Cupones',
    'coupon.use': 'Usar Ahora',
    'coupon.used': 'Usado',
    'coupon.toUse': 'Por Usar',
    'coupon.all': 'Todos',
    'coupon.unavailable': 'No hay cupones disponibles',
    'coupon.apply': 'Aplicar Cupón',
    'coupon.enterCode': 'Ingresa el código de cupón',
    'coupon.applySuccess': '¡Cupón aplicado!',
    'coupon.select': 'Seleccionar Cupón',
    'coupon.validUntil': 'Válido hasta',
    'coupon.condition': 'Condiciones',
    'coupon.range': 'Alcance',
    'coupon.amountOff': 'Descuento Fijo',
    'coupon.percentOff': 'Descuento %',
    'coupon.offPrefix': 'Dto.',
    'coupon.noCoupon': 'No usar cupón',
    'coupon.claimCenter': 'Centro de Cupones',
    'coupon.noAvailable': 'No hay cupones disponibles',
    'coupon.alreadyClaimed': 'Ya reclamado',
    'coupon.platform': 'Cupón de Plataforma',

    // 收货地址
    'addr.name': 'Nombre',
    'addr.phone': 'Teléfono',
    'addr.detail': 'Dirección',
    'addr.default': 'Predeterminado',
    'addr.setDefault': 'Establecer como predeterminado',
    'addr.add': 'Añadir dirección',
    'addr.edit': 'Editar dirección',
    'addr.delete': 'Eliminar dirección',
    'addr.save': 'Guardar',

    'notif.title': 'Notificaciones',
    'notif.readAll': 'Marcar todo como leído',
    'notif.empty': 'Sin notificaciones',
    'notif.unread': 'no leídos',

    'review.title': 'Reseñas',
    'review.write': 'Escribir reseña',
    'review.rating': 'Calificación',
    'review.content': 'Contenido',
    'review.submit': 'Enviar',
    'review.avg': 'Promedio',
    'review.total': 'reseñas',
    'review.submitted': '¡Reseña enviada! ⭐',
    'review.exists': 'Ya escribiste una reseña',
        // 商家入驻
    'merchant.apply': 'Solicitar como Vendedor',
    'merchant.name': 'Nombre de la Tienda',
    'merchant.contact': 'Persona de Contacto',
    'merchant.phone': 'Número de Teléfono *',
    'merchant.desc': 'Descripción de la Tienda',
    'merchant.agree': 'Acepto el Acuerdo de Servicio para Vendedores',
    'merchant.submit': 'Enviar Solicitud',
    'merchant.status': 'Estado de la Solicitud',
    'merchant.pending': '⏳ En Revisión',
    'merchant.approved': '✅ Aprobado',
    'merchant.rejected': '❌ Rechazado',
    'merchant.none': 'No ha solicitado',
    'merchant.myStore': 'Mi Tienda',
    'merchant.storeName': 'Nombre de la Tienda *',
    'merchant.welcome': '¡Bienvenido, Vendedor!',
    'merchant.applySuccess': '¡Solicitud enviada! La revisaremos pronto.',
    'merchant.applyFail': 'Error al enviar la solicitud',
    'merchant.alreadyApplied': 'Ya has enviado una solicitud',
    'merchant.dashboard': 'Panel de Vendedor',
    'merchant.products': 'Mis Productos',
    'merchant.orders': 'Pedidos de la Tienda',
    'merchant.income': 'Ingresos',
    'merchant.comingSoon': 'Funciones de vendedor próximamente',
    'merchant.fillRequired': 'Por favor completa todos los campos obligatorios',
    'merchant.uploadIdCard': 'Por favor sube ambos lados de tu identificación',
    'merchant.uploadEnterprise': 'Por favor sube la licencia comercial y el ID del representante legal',
    'merchant.typeLabel': 'Tipo de Vendedor *',
    'merchant.typePersonal': '👤 Individual',
    'merchant.typeEnterprise': '🏢 Empresa',
    'merchant.countryLabel': 'País/Región *',
    'merchant.contactName': 'Nombre de Contacto *',
    'merchant.email': 'Correo Electrónico *',
    'merchant.personalQualification': 'Documentos Personales',
    'merchant.idCardFront': 'Frente del ID *',
    'merchant.idCardBack': 'Reverso del ID *',
    'merchant.enterpriseQualification': 'Documentos Empresariales',
    'merchant.businessLicense': 'Licencia Comercial *',
    'merchant.legalIdCard': 'ID del Representante Legal *',
    'merchant.agreement': 'He leído y acepto el Acuerdo de Vendedor',
    'merchant.newStore': 'Abrir Nueva Tienda',
    'merchant.storeCount': '已开{current}/{max}家',
    'merchant.rejectReasonLabel': 'Razón:',
    'merchant.reapply': 'Volver a Solicitar',
    // ===== 商家优惠券表单（新增）=====
    'tab.coupons': '🎫 Cupones',
    'merchant.coupons': '🎫 Mis Cupones',
    'merchant.createCoupon': 'Crear Cupón',
    'label.code': 'Código',
    'label.discount': 'Descuento',
    'label.type': 'Tipo',
    'label.minOrder': 'Compra Mín.',
    'label.maxUses': 'Usos Máx.',
    'label.validUntil': 'Válido Hasta',
    'label.used': 'Usado',
    'label.action': 'Acción',
    'coupon.fixed': 'Monto Fijo (π)',
    'coupon.percent': 'Porcentaje (%)',
    'text.noData': 'Aún no hay cupones',
    'text.unlimited': 'Ilimitado',
    'btn.create': 'Crear',
    'btn.cancel': 'Cancelar',
    'btn.delete': 'Eliminar',

    // ===== 新增：商家优惠券管理 =====
    'mc.title': 'Gestión de Cupones',
    'mc.create': 'Crear Cupón',
    'mc.edit': 'Editar Cupón',
    'mc.delete': 'Eliminar',
    'mc.name': 'Nombre del Cupón',
    'mc.code': 'Código',
    'mc.type': 'Tipo de Cupón',
    'mc.amountOff': 'Descuento Fijo',
    'mc.percentOff': 'Descuento %',
    'mc.discountValue': 'Valor del Descuento',
    'mc.minOrderAmount': 'Monto Mínimo de Compra',
    'mc.totalQuantity': 'Cantidad Total',
    'mc.limitPerUser': 'Límite por Usuario',
    'mc.startTime': 'Fecha de Inicio',
    'mc.endTime': 'Fecha de Fin',
    'mc.active': 'Activo',
    'mc.inactive': 'Finalizado',
    'mc.createSuccess': '¡Cupón creado!',
    'mc.updateSuccess': '¡Cupón actualizado!',
    'mc.deleteConfirm': '¿Eliminar este cupón?',
    'mc.noCoupons': 'Aún no hay cupones',

    'mp.add': 'Añadir producto',
    'mp.edit': 'Editar producto',
    'mp.delete': 'Eliminar producto',
    'mp.name': 'Nombre del producto',
    'mp.image': 'URL de imagen',
    'mp.price': 'Precio Pi',
    'mp.originalPrice': 'Precio original ¥',
    'mp.category': 'Categoría',
    'cat.clothing': 'Ropa/Zapatos/Bolsos',
    'cat.digital': 'Móviles/Digital',
    'cat.appliances': 'Electrodomésticos',
    'cat.home': 'Hogar/Decoración',
    'cat.beauty': 'Belleza/Cuidado',
    'cat.baby': 'Bebé/Juguetes',
    'cat.food': 'Alimentos/Fresco',
    'cat.sports': 'Deportes/Outdoor',
    'cat.auto': 'Accesorios Coche',
    'cat.books': 'Libros/Entretenimiento',
    'cat.pets': 'Mascotas',
    'cat.health': 'Medicina/Salud',
    'cat.garden': 'Agrícola/Jardinería',
    'cat.industrial': 'Industrial/Herramientas',
    'cat.virtual': 'Virtual/Servicios',
        // 服饰鞋包子类
    'cat.clothing_women': 'Mujer',
    'cat.clothing_men': 'Hombre',
    'cat.clothing_kids': 'Niños',
    'cat.clothing_underwear': 'Ropa Interior',
    'cat.clothing_shoes': 'Zapatos',
    'cat.clothing_bags': 'Bolsos',
    'cat.clothing_accessories': 'Accesorios',
    'cat.clothing_jewelry': 'Joyería',
    'cat.clothing_glasses': 'Gafas',
    'cat.clothing_watches': 'Relojes',
    // 手机数码子类
    'cat.digital_phone': 'Móviles',
    'cat.digital_acc': 'Accesorios Móvil',
    'cat.digital_computer': 'Ordenadores',
    'cat.digital_tablet': 'Tablets',
    'cat.digital_camera': 'Cámaras',
    'cat.digital_smart': 'Dispositivos Inteligentes',
    'cat.digital_audio': 'Audio',
    'cat.digital_office': 'Oficina',
    // 家用电器子类
    'cat.appliances_major': 'Grandes Electrodomésticos',
    'cat.appliances_kitchen': 'Cocina',
    'cat.appliances_living': 'Hogar',
    'cat.appliances_personal': 'Cuidado Personal',
    // 家居家装子类
    'cat.home_furniture': 'Muebles',
    'cat.home_textile': 'Textil Hogar',
    'cat.home_kitchenware': 'Cocina/Mesa',
    'cat.home_storage': 'Almacenamiento',
    'cat.home_decor': 'Decoración',
    'cat.home_lighting': 'Iluminación',
    'cat.home_bathroom': 'Baño',
    'cat.home_materials': 'Materiales',
    // 美妆个护子类
    'cat.beauty_skincare': 'Cuidado Facial',
    'cat.beauty_makeup': 'Maquillaje',
    'cat.beauty_perfume': 'Perfumes',
    'cat.beauty_hair': 'Cabello',
    'cat.beauty_oral': 'Higiene Oral',
    'cat.beauty_body': 'Cuerpo',
    'cat.beauty_men': 'Hombres',
    'cat.beauty_tools': 'Herramientas',
    // 母婴玩具子类
    'cat.baby_formula': 'Leche/Alimentos',
    'cat.baby_diapers': 'Pañales',
    'cat.baby_gear': 'Productos Bebé',
    'cat.baby_clothing': 'Ropa Bebé',
    'cat.baby_toys': 'Juguetes',
    'cat.baby_maternity': 'Maternidad',
    'cat.baby_edu': 'Educación/Música',
    // 食品生鲜子类
    'cat.food_snacks': 'Snacks',
    'cat.food_grain': 'Cereales/Salsas',
    'cat.food_drinks': 'Bebidas/Lácteos',
    'cat.food_fresh': 'Frescos',
    'cat.food_alcohol': 'Alcohol',
    'cat.food_health': 'Saludable',
    'cat.food_instant': 'Instantáneo',
    // 运动户外子类
    'cat.sports_wear': 'Ropa Deportiva',
    'cat.sports_shoes': 'Zapatillas',
    'cat.sports_fitness': 'Fitness',
    'cat.sports_outdoor': 'Outdoor',
    'cat.sports_cycling': 'Ciclismo',
    'cat.sports_balls': 'Pelotas',
    'cat.sports_swimming': 'Natación',
    'cat.sports_yoga': 'Yoga',
    // 汽车用品子类
    'cat.auto_interior': 'Interior',
    'cat.auto_exterior': 'Exterior',
    'cat.auto_parts': 'Repuestos',
    'cat.auto_maintenance': 'Mantenimiento',
    'cat.auto_elec': 'Electrónica',
    'cat.auto_tires': 'Neumáticos',
    'cat.auto_tools': 'Herramientas',
    // 图书文娱子类
    'cat.books_book': 'Libros',
    'cat.books_av': 'Audio/Video',
    'cat.books_ebook': 'E-books',
    'cat.books_film': 'Cine',
    'cat.books_games': 'Videojuegos',
    'cat.books_anime': 'Anime',
    'cat.books_instruments': 'Instrumentos',
    'cat.books_creative': 'Papelería',
    // 宠物用品子类
    'cat.pets_food': 'Alimento',
    'cat.pets_snacks': 'Snacks',
    'cat.pets_toys': 'Juguetes',
    'cat.pets_beds': 'Camas',
    'cat.pets_wash': 'Higiene',
    'cat.pets_med': 'Veterinaria',
    'cat.pets_aquarium': 'Acuario',
    // 医药健康子类
    'cat.health_medicine': 'Medicamentos',
    'cat.health_devices': 'Dispositivos Médicos',
    'cat.health_supplements': 'Suplementos',
    'cat.health_equipment': 'Equipos',
    'cat.health_adult': 'Adultos',
    'cat.health_tcm': 'Medicina Tradicional',
    // 农资园艺子类
    'cat.garden_seeds': 'Semillas',
    'cat.garden_fertilizer': 'Fertilizantes',
    'cat.garden_tools': 'Herramientas Jardín',
    'cat.garden_pots': 'Macetas/Tierra',
    'cat.garden_plants': 'Plantas',
    'cat.garden_machinery': 'Maquinaria',
    // 工业品/工具子类
    'cat.industrial_hardware': 'Ferretería',
    'cat.industrial_electrical': 'Eléctrico',
    'cat.industrial_safety': 'Seguridad',
    'cat.industrial_security': 'Vigilancia',
    'cat.industrial_packaging': 'Embalaje',
    'cat.industrial_consumables': 'Consumibles',
    // 虚拟/服务子类
    'cat.virtual_phone': 'Recarga Móvil',
    'cat.virtual_game': 'Tarjetas Juego',
    'cat.virtual_member': 'Membresía',
    'cat.virtual_local': 'Vida Local',
    'cat.virtual_housekeeping': 'Limpieza',
    'cat.virtual_education': 'Cursos',

    'mp.description': 'Descripción',
    'mp.stock': 'Stock',
    'mp.published': 'Publicado',
    'mp.hidden': 'Oculto',
    'mp.myProducts': 'Mis productos',
    'mp.noProducts': 'Sin productos',
    'mp.addSuccess': '¡Producto añadido!',
    'mp.updateSuccess': '¡Producto actualizado!',
    'mp.deleteConfirm': '¿Eliminar este producto?',
    'mp.stockLeft': 'en stock',
    'store.title': 'Tienda',
    'store.products': 'Todos los productos',
    'store.noProducts': 'Esta tienda no tiene productos',
    'store.visit': 'Visitar tienda',
    'store.loading': 'Cargando...',
    'store.merchantNotFound': 'Comerciante no encontrado',
    'store.loadFailed': 'Error al cargar',
    'store.backHome': 'Volver al inicio',
    'store.joined': 'Se unió',
    'store.allCategories': 'Todo',
    'store.sold': 'Vendidos',
    // 商家订单
    'mo.pendingShip': 'Pendiente de envío',
    'mo.shipped': 'Enviado',
    'mo.completed': 'Completado',
    'mo.refundPending': 'Reembolso pendiente',
    'mo.noOrders': 'Sin pedidos',
    'mo.items': 'artículos',
    'mo.refundReason': 'Motivo del reembolso',
    'mo.tracking': 'Seguimiento',
    'mo.orderTime': 'Fecha del pedido',
    'mo.shipTime': 'Fecha de envío',
    'mo.ship': 'Enviar',
    'mo.enterTracking': 'Ingrese número de seguimiento',
    'mo.confirmShip': 'Confirmar',
    'mo.confirmComplete': 'Confirmar completado',
    'mo.approveRefund': 'Aprobar reembolso',
    'mo.rejectRefund': 'Rechazar reembolso',
    'mo.approveRefundConfirm': '¿Aprobar este reembolso?',
    //买家订单
    'bo.viewDetail': 'Ver detalle',
    'bo.orderDetail': 'Detalle del pedido',
    'bo.stepPaid': 'Pagado',
    'bo.stepShipped': 'Enviado',
    'bo.stepCompleted': 'Completado',
    'bo.refundProcessing': 'Reembolso en proceso',
    'bo.refundApproved': 'Reembolso aprobado',
    'bo.refundRejected': 'Reembolso rechazado',
    'bo.productInfo': 'Info del producto',
    'bo.shippingInfo': 'Info de envío',
    'bo.orderInfo': 'Info del pedido',
    'bo.completeTime': 'Completado el',
    'bo.requestRefund': 'Solicitar reembolso',
    'bo.refundReason': 'Motivo del reembolso',
    'bo.refundReasonPlaceholder': 'Describe el motivo del reembolso...',
    'bo.submitRefund': 'Enviar solicitud',
    'bo.refundAlreadyRequested': 'Reembolso ya solicitado',

    'stats.title': 'Estadísticas', 'stats.todaySales': 'Ventas hoy', 'stats.weekSales': 'Ventas semanales', 'stats.monthSales': 'Ventas mensuales', 'stats.totalSales': 'Ventas totales', 'stats.orderCount': 'Pedidos', 'stats.productCount': 'Productos', 'stats.pendingShip': 'Pendiente de envío', 'stats.refundPending': 'Reembolso pendiente', 'stats.productRanking': 'Ranking de productos', 'stats.sales': 'Ventas', 'stats.orderNum': 'Pedidos', 'stats.noData': 'Sin datos',
    
    'app.name': '314PiMall',
    'loading': 'Cargando...',
    'cancel': 'Cancelar',
    'confirm': 'Confirmar',
    'delete': 'Eliminar',
    'edit': 'Editar',
    'save': 'Guardar',
    'close': 'Cerrar',
    'success': 'Éxito',
    'failed': 'Fallido',
    'search': 'Buscar producto',
    'noResults': 'No se encontraron productos para',
    'copy': 'Copiar todo',
    'copied': '¡Copiado!',
    'nav.home': 'Inicio',
    'nav.class': 'Categorías',
    'nav.cart': 'Carrito',
    'nav.mine': 'Mío',
    'home.banner.title': '🛍️ 314PiMall Plataforma Multivendedor',
    'home.banner.desc': 'Descubre miles de productos de comerciantes Pi de confianza',
    'home.seckill': '⚡ Oferta flash',
    'home.recommend': '🔥 Recomendado',
    'home.more': 'Más ›',
    'home.results': 'Resultados',
    'detail.title': 'Detalle del producto',
    'detail.addCart': 'Añadir al carrito',
    'detail.buyNow': 'Comprar ahora',
    'detail.description': 'Descripción',
    'detail.sold': 'vendidos',
    'cart.title': '🛒 Carrito',
    'cart.empty': 'El carrito está vacío',
    'cart.emptyDesc': '¡Empieza a comprar!',
    'cart.total': 'Total:',
    'cart.checkout': 'Pagar',
    'cart.processing': 'Procesando...',
    'cart.added': '¡Añadido al carrito! 🛒',
    'pay.success': '¡Pago exitoso! 🎉',
    'pay.failed': 'Pago fallido, inténtalo de nuevo',
    'pay.openPi': 'Por favor, ábrelo en Pi Browser',
    'mine.user': 'Usuario Pi',
    'mine.signIn': 'Inicia sesión para ver tu perfil',
    'mine.signOut': 'Cerrar sesión',
    'mine.pending': 'Pendiente',
    'mine.shipping': 'Enviando',
    'mine.completed': 'Completado',
    'mine.returns': 'Devoluciones',
    'mine.orders': 'Mis pedidos',
    'mine.wallet': 'Billetera Pi',
    'mine.coupons': 'Mis cupones',
    'mine.address': 'Dirección de envío',
    'mine.favorites': 'Favoritos',
    'mine.history': 'Historial de transacciones',
    'mine.settings': 'Configuración',
    'mine.service': 'Servicio al cliente',
    'mine.noOrders': 'Sin pedidos aún',
    'mine.noTx': 'Sin transacciones aún',
    'mine.walletDesc': 'Revisa tu billetera Pi en Pi Browser',
    'mine.noCoupons': 'Sin cupones disponibles',
    'mine.noAddress': 'Sin dirección guardada',
    'mine.noFavorites': 'Sin favoritos aún',
    'mine.comingSoon': 'Próximamente',
    'mine.orderNum': 'Pedido',
    'mine.payment': 'Pago',
    'order.refunded': '💸 Reembolsado',
    'order.cancelled': '❌ Cancelado',
    'order.completed': '✅ Completado',
    'order.pending': '⏳ Pendiente',
    'lang.title': 'Idioma',
    'finance.title': 'Finanzas',
    'finance.overview': 'Resumen de ingresos',
    'finance.totalEarnings': 'Ingresos totales',
    'finance.totalWithdrawn': 'Total retirado',
    'finance.balance': 'Saldo disponible',
    'finance.pendingSettlements': 'Liquidación pendiente',
    'finance.pendingWithdrawals': 'Retiro pendiente',
    'finance.transactions': 'Detalles de transacción',
    'finance.withdrawals': 'Registros de retiro',
    'finance.withdraw': 'Retirar',
    'finance.withdrawAmount': 'Monto de retiro',
    'finance.piWallet': 'Dirección de billetera Pi',
    'finance.withdrawSubmit': 'Solicitar retiro',
    'finance.withdrawSuccess': '¡Solicitud de retiro enviada!',
    'finance.withdrawFail': 'Retiro fallido',
    'finance.insufficientBalance': 'Saldo insuficiente',
    'finance.noTransactions': 'Sin transacciones',
    'finance.noWithdrawals': 'Sin registros de retiro',
    'finance.type': 'Tipo',
    'finance.amount': 'Monto',
    'finance.commission': 'Comisión',
    'finance.netAmount': 'Ingreso neto',
    'finance.status': 'Estado',
    'finance.time': 'Hora',
    'finance.settlement': 'Liquidación',
    'finance.withdrawal': 'Retiro',
    'finance.pendingStatus': 'Pendiente',
    'finance.completedStatus': 'Completado',
    'finance.rejectedStatus': 'Rechazado',

  },
  vi: {
    'fav.add': 'Thêm yêu thích',
    'fav.remove': 'Bỏ yêu thích',
    'fav.added': 'Đã thêm yêu thích ❤️',
    'fav.removed': 'Đã bỏ yêu thích',

        // 优惠券
    'coupon.claim': 'Nhận Mã Giảm Giá',
    'coupon.code': 'Nhập mã giảm giá',
    'coupon.claimed': 'Đã nhận mã giảm giá! 🎉',
    'coupon.invalid': 'Mã giảm giá không hợp lệ',
    'coupon.expired': 'Mã giảm giá đã hết hạn',
    'coupon.discount': 'Giảm',
    'coupon.minOrder': 'Đơn Tối Thiểu',
    // ===== 新增：用户端优惠券 =====
    'coupon.title': 'Mã Giảm Giá',
    'coupon.myCoupons': 'Mã Giảm Giá Của Tôi',
    'coupon.use': 'Dùng Ngay',
    'coupon.used': 'Đã Dùng',
    'coupon.toUse': 'Chưa Dùng',
    'coupon.all': 'Tất Cả',
    'coupon.unavailable': 'Không có mã giảm giá khả dụng',
    'coupon.apply': 'Áp Dụng Mã',
    'coupon.enterCode': 'Nhập mã giảm giá',
    'coupon.applySuccess': 'Đã áp dụng mã giảm giá!',
    'coupon.select': 'Chọn Mã Giảm Giá',
    'coupon.validUntil': 'Có hiệu lực đến',
    'coupon.condition': 'Điều kiện sử dụng',
    'coupon.range': 'Phạm vi áp dụng',
    'coupon.amountOff': 'Giảm Theo Số Tiền',
    'coupon.percentOff': 'Giảm Theo %',
    'coupon.offPrefix': 'Giảm',
    'coupon.noCoupon': 'Không dùng mã giảm giá',
    'coupon.claimCenter': 'Trung Tâm Mã Giảm Giá',
    'coupon.noAvailable': 'Không có mã giảm giá khả dụng',
    'coupon.alreadyClaimed': 'Đã nhận rồi',
    'coupon.platform': 'Mã Nền Tảng',

    // 收货地址
    'addr.name': 'Họ và Tên',
    'addr.phone': 'Số điện thoại',
    'addr.detail': 'Địa chỉ',
    'addr.default': 'Mặc định',
    'addr.setDefault': 'Đặt làm mặc định',
    'addr.add': 'Thêm địa chỉ',
    'addr.edit': 'Sửa địa chỉ',
    'addr.delete': 'Xóa địa chỉ',
    'addr.save': 'Lưu',

    'notif.title': 'Thông báo',
    'notif.readAll': 'Đọc tất cả',
    'notif.empty': 'Không có thông báo',
    'notif.unread': 'chưa đọc',

    'review.title': 'Đánh giá',
    'review.write': 'Viết đánh giá',
    'review.rating': 'Điểm',
    'review.content': 'Nội dung',
    'review.submit': 'Gửi',
    'review.avg': 'Trung bình',
    'review.total': 'đánh giá',
    'review.submitted': 'Đánh giá đã gửi! ⭐',
    'review.exists': 'Bạn đã đánh giá sản phẩm này',
        // 商家入驻
    'merchant.apply': 'Đăng Ký Làm Người Bán',
    'merchant.name': 'Tên Cửa Hàng',
    'merchant.contact': 'Người Liên Hệ',
    'merchant.phone': 'Số Điện Thoại *',
    'merchant.desc': 'Giới Thiệu Cửa Hàng',
    'merchant.agree': 'Tôi đồng ý với Thỏa Thuận Dịch Vụ Người Bán',
    'merchant.submit': 'Gửi Đơn Đăng Ký',
    'merchant.status': 'Trạng Thái Đơn',
    'merchant.pending': '⏳ Đang Xét Duyệt',
    'merchant.approved': '✅ Đã Duyệt',
    'merchant.rejected': '❌ Bị Từ Chối',
    'merchant.none': 'Chưa Đăng Ký',
    'merchant.myStore': 'Cửa Hàng Của Tôi',
    'merchant.storeName': 'Tên Cửa Hàng *',
    'merchant.welcome': 'Chào mừng, Người Bán!',
    'merchant.applySuccess': 'Đã gửi đơn đăng ký! Chúng tôi sẽ xem xét sớm.',
    'merchant.applyFail': 'Gửi đơn thất bại',
    'merchant.alreadyApplied': 'Bạn đã gửi đơn đăng ký rồi',
    'merchant.dashboard': 'Trung Tâm Người Bán',
    'merchant.products': 'Sản Phẩm Của Tôi',
    'merchant.orders': 'Đơn Hàng Cửa Hàng',
    'merchant.income': 'Thu Nhập',
    'merchant.comingSoon': 'Tính năng người bán sắp ra mắt',
    'merchant.fillRequired': 'Vui lòng điền đầy đủ thông tin bắt buộc',
    'merchant.uploadIdCard': 'Vui lòng tải lên mặt trước và sau CMND/CCCD',
    'merchant.uploadEnterprise': 'Vui lòng tải lên giấy phép kinh doanh và CMND người đại diện',
    'merchant.typeLabel': 'Loại Người Bán *',
    'merchant.typePersonal': '👤 Cá Nhân',
    'merchant.typeEnterprise': '🏢 Doanh Nghiệp',
    'merchant.countryLabel': 'Quốc Gia/Khu Vực *',
    'merchant.contactName': 'Tên Người Liên Hệ *',
    'merchant.email': 'Email *',
    'merchant.personalQualification': 'Tư Cách Cá Nhân',
    'merchant.idCardFront': 'CMND Mặt Trước *',
    'merchant.idCardBack': 'CMND Mặt Sau *',
    'merchant.enterpriseQualification': 'Tư Cách Doanh Nghiệp',
    'merchant.businessLicense': 'Giấy Phép Kinh Doanh *',
    'merchant.legalIdCard': 'CMND Người Đại Diện *',
    'merchant.agreement': 'Tôi đã đọc và đồng ý với Thỏa Thuận Đăng Ký Người Bán',
    'merchant.newStore': 'Mở Cửa Hàng Mới',
    'merchant.storeCount': '已开{current}/{max}家',
    'merchant.rejectReasonLabel': 'Lý do từ chối:',
    'merchant.reapply': 'Đăng Ký Lại',
    // ===== 商家优惠券表单（新增）=====
    'tab.coupons': '🎫 Mã Giảm Giá',
    'merchant.coupons': '🎫 Mã Của Tôi',
    'merchant.createCoupon': 'Tạo Mã',
    'label.code': 'Mã',
    'label.discount': 'Giá Trị Giảm',
    'label.type': 'Loại',
    'label.minOrder': 'Đơn Tối Thiểu',
    'label.maxUses': 'Số Lần Tối Đa',
    'label.validUntil': 'Hiệu Lực Đến',
    'label.used': 'Đã Dùng',
    'label.action': 'Thao Tác',
    'coupon.fixed': 'Cố Định (π)',
    'coupon.percent': 'Phần Trăm (%)',
    'text.noData': 'Chưa có mã giảm giá',
    'text.unlimited': 'Không Giới Hạn',
    'btn.create': 'Tạo',
    'btn.cancel': 'Hủy',
    'btn.delete': 'Xóa',

    // ===== 新增：商家优惠券管理 =====
    'mc.title': 'Quản Lý Mã Giảm Giá',
    'mc.create': 'Tạo Mã Giảm Giá',
    'mc.edit': 'Chỉnh Sửa',
    'mc.delete': 'Xóa',
    'mc.name': 'Tên Mã Giảm Giá',
    'mc.code': 'Mã Code',
    'mc.type': 'Loại Mã',
    'mc.amountOff': 'Giảm Theo Số Tiền',
    'mc.percentOff': 'Giảm Theo %',
    'mc.discountValue': 'Giá Trị Giảm',
    'mc.minOrderAmount': 'Đơn Hàng Tối Thiểu',
    'mc.totalQuantity': 'Tổng Số Lượng Phát Hành',
    'mc.limitPerUser': 'Giới Hạn Mỗi Người',
    'mc.startTime': 'Thời Gian Bắt Đầu',
    'mc.endTime': 'Thời Gian Kết Thúc',
    'mc.active': 'Đang Diễn Ra',
    'mc.inactive': 'Đã Kết Thúc',
    'mc.createSuccess': 'Đã tạo mã giảm giá!',
    'mc.updateSuccess': 'Đã cập nhật mã giảm giá!',
    'mc.deleteConfirm': 'Xóa mã giảm giá này?',
    'mc.noCoupons': 'Chưa có mã giảm giá',

    'mp.add': 'Thêm sản phẩm',
    'mp.edit': 'Sửa sản phẩm',
    'mp.delete': 'Xóa sản phẩm',
    'mp.name': 'Tên sản phẩm',
    'mp.image': 'URL hình ảnh',
    'mp.price': 'Giá Pi',
    'mp.originalPrice': 'Giá gốc ¥',
    'mp.category': 'Danh mục',
    'cat.clothing': 'Thời Trang/Giày/Túi',
    'cat.digital': 'Điện Thoại/Số',
    'cat.appliances': 'Điện Gia Dụng',
    'cat.home': 'Nhà Cửa/Nội Thất',
    'cat.beauty': 'Làm Đẹp/Chăm Sóc',
    'cat.baby': 'Mẹ & Bé/Đồ Chơi',
    'cat.food': 'Thực Phẩm/Tươi Sống',
    'cat.sports': 'Thể Thao/Ngoài Trời',
    'cat.auto': 'Phụ Kiện Ô Tô',
    'cat.books': 'Sách/Giải Trí',
    'cat.pets': 'Thú Cưng',
    'cat.health': 'Y Tế/Sức Khỏe',
    'cat.garden': 'Nông Cục/Làm Vườn',
    'cat.industrial': 'Công Nghiệp/Dụng Cụ',
    'cat.virtual': 'Ảo/Dịch Vụ',
        // 服饰鞋包子类
    'cat.clothing_women': 'Nữ',
    'cat.clothing_men': 'Nam',
    'cat.clothing_kids': 'Trẻ Em',
    'cat.clothing_underwear': 'Đồ Lót',
    'cat.clothing_shoes': 'Giày Dép',
    'cat.clothing_bags': 'Túi Xách',
    'cat.clothing_accessories': 'Phụ Kiện',
    'cat.clothing_jewelry': 'Trang Sức',
    'cat.clothing_glasses': 'Kính Mắt',
    'cat.clothing_watches': 'Đồng Hồ',
    // 手机数码子类
    'cat.digital_phone': 'Điện Thoại',
    'cat.digital_acc': 'Phụ Kiện Điện Thoại',
    'cat.digital_computer': 'Máy Tính',
    'cat.digital_tablet': 'Máy Tính Bảng',
    'cat.digital_camera': 'Máy Ảnh',
    'cat.digital_smart': 'Thiết Bị Thông Minh',
    'cat.digital_audio': 'Âm Thanh',
    'cat.digital_office': 'Văn Phòng',
    // 家用电器子类
    'cat.appliances_major': 'Điện Lạnh',
    'cat.appliances_kitchen': 'Điện Nhà Bếp',
    'cat.appliances_living': 'Điện Gia Dụng',
    'cat.appliances_personal': 'Chăm Sóc Cá Nhân',
    // 家居家装子类
    'cat.home_furniture': 'Nội Thất',
    'cat.home_textile': 'Đồ Dệt',
    'cat.home_kitchenware': 'Đồ Bếp',
    'cat.home_storage': 'Lưu Trữ/Vệ Sinh',
    'cat.home_decor': 'Trang Trí',
    'cat.home_lighting': 'Đèn',
    'cat.home_bathroom': 'Phòng Tắm',
    'cat.home_materials': 'Vật Liệu',
    // 美妆个护子类
    'cat.beauty_skincare': 'Chăm Sóc Da',
    'cat.beauty_makeup': 'Trang Điểm',
    'cat.beauty_perfume': 'Nước Hoa',
    'cat.beauty_hair': 'Tóc',
    'cat.beauty_oral': 'Chăm Sóc Răng',
    'cat.beauty_body': 'Chăm Sóc Cơ Thể',
    'cat.beauty_men': 'Nam Giới',
    'cat.beauty_tools': 'Dụng Cụ',
    // 母婴玩具子类
    'cat.baby_formula': 'Sữa/Đồ Ăn Dặm',
    'cat.baby_diapers': 'Tã Giấy',
    'cat.baby_gear': 'Đồ Dùng Em Bé',
    'cat.baby_clothing': 'Quần Áo Trẻ',
    'cat.baby_toys': 'Đồ Chơi',
    'cat.baby_maternity': 'Đồ Bầu',
    'cat.baby_edu': 'Giáo Dục/Nhạc Cụ',
    // 食品生鲜子类
    'cat.food_snacks': 'Đồ Ăn Vặt',
    'cat.food_grain': 'Ngũ Cốc/Gia Vị',
    'cat.food_drinks': 'Đồ Uống/Sữa',
    'cat.food_fresh': 'Thực Phẩm Tươi Sống',
    'cat.food_alcohol': 'Rượu',
    'cat.food_health': 'Bổ Dưỡng',
    'cat.food_instant': 'Đồ Ăn Liền',
    // 运动户外子类
    'cat.sports_wear': 'Đồ Thể Thao',
    'cat.sports_shoes': 'Giày Thể Thao',
    'cat.sports_fitness': 'Dụng Cụ Gym',
    'cat.sports_outdoor': 'Đồ Dã Ngoại',
    'cat.sports_cycling': 'Đồ Đạp Xe',
    'cat.sports_balls': 'Bóng',
    'cat.sports_swimming': 'Đồ Bơi',
    'cat.sports_yoga': 'Yoga',
    // 汽车用品子类
    'cat.auto_interior': 'Nội Thất Xe',
    'cat.auto_exterior': 'Ngoại Thất Xe',
    'cat.auto_parts': 'Phụ Tùng',
    'cat.auto_maintenance': 'Bảo Dưỡng',
    'cat.auto_elec': 'Điện Tử Xe',
    'cat.auto_tires': 'Lốp/Vành',
    'cat.auto_tools': 'Dụng Cụ',
    // 图书文娱子类
    'cat.books_book': 'Sách',
    'cat.books_av': 'Âm Thanh/Hình Ảnh',
    'cat.books_ebook': 'E-book',
    'cat.books_film': 'Phim Ảnh',
    'cat.books_games': 'Trò Chơi',
    'cat.books_anime': 'Hoạt Hình',
    'cat.books_instruments': 'Nhạc Cụ',
    'cat.books_creative': 'Văn Phòng Phẩm',
    // 宠物用品子类
    'cat.pets_food': 'Thức Ăn Thú Cưng',
    'cat.pets_snacks': 'Đồ Ăn Vặt',
    'cat.pets_toys': 'Đồ Chơi',
    'cat.pets_beds': 'Chuồng/Nệm',
    'cat.pets_wash': 'Tắm/Gội',
    'cat.pets_med': 'Y Tế Thú Y',
    'cat.pets_aquarium': 'Cá Cảnh',
    // 医药健康子类
    'cat.health_medicine': 'Thuốc',
    'cat.health_devices': 'Thiết Bị Y Tế',
    'cat.health_supplements': 'Thực Phẩm Chức Năng',
    'cat.health_equipment': 'Dụng Cụ Sức Khỏe',
    'cat.health_adult': 'Người Lớn',
    'cat.health_tcm': 'Đông Y',
    // 农资园艺子类
    'cat.garden_seeds': 'Hạt Giống',
    'cat.garden_fertilizer': 'Phân Bón',
    'cat.garden_tools': 'Dụng Cụ Làm Vườn',
    'cat.garden_pots': 'Chậu/Đất',
    'cat.garden_plants': 'Cây Cảnh',
    'cat.garden_machinery': 'Máy Nông Nghiệp',
    // 工业品/工具子类
    'cat.industrial_hardware': 'Kim Khí',
    'cat.industrial_electrical': 'Điện Công Nghiệp',
    'cat.industrial_safety': 'Bảo Hộ',
    'cat.industrial_security': 'An Ninh',
    'cat.industrial_packaging': 'Bao Bì',
    'cat.industrial_consumables': 'Vật Tư',
    // 虚拟/服务子类
    'cat.virtual_phone': 'Nạp Tiền ĐT',
    'cat.virtual_game': 'Thẻ Game',
    'cat.virtual_member': 'Hội Viên',
    'cat.virtual_local': 'Đời Sống',
    'cat.virtual_housekeeping': 'Giúp Việc',
    'cat.virtual_education': 'Khóa Học',

    'mp.description': 'Mô tả',
    'mp.stock': 'Tồn kho',
    'mp.published': 'Đang bán',
    'mp.hidden': 'Đã ẩn',
    'mp.myProducts': 'Sản phẩm của tôi',
    'mp.noProducts': 'Chưa có sản phẩm',
    'mp.addSuccess': 'Đã thêm sản phẩm!',
    'mp.updateSuccess': 'Đã cập nhật sản phẩm!',
    'mp.deleteConfirm': 'Xóa sản phẩm này?',
    'mp.stockLeft': 'tồn kho',
    'store.title': 'Cửa hàng',
    'store.products': 'Tất cả sản phẩm',
    'store.noProducts': 'Cửa hàng chưa có sản phẩm',
    'store.visit': 'Ghé thăm cửa hàng',
    'store.loading': 'Đang tải...',
    'store.merchantNotFound': 'Không tìm thấy người bán',
    'store.loadFailed': 'Tải thất bại',
    'store.backHome': 'Về trang chủ',
    'store.joined': 'Tham gia',
    'store.allCategories': 'Tất cả',
    'store.sold': 'Đã bán',
    // 商家订单
    'mo.pendingShip': 'Chờ giao hàng',
    'mo.shipped': 'Đã giao',
    'mo.completed': 'Hoàn thành',
    'mo.refundPending': 'Chờ hoàn tiền',
    'mo.noOrders': 'Không có đơn hàng',
    'mo.items': 'sản phẩm',
    'mo.refundReason': 'Lý do hoàn tiền',
    'mo.tracking': 'Mã vận đơn',
    'mo.orderTime': 'Thời gian đặt',
    'mo.shipTime': 'Thời gian giao',
    'mo.ship': 'Giao hàng',
    'mo.enterTracking': 'Nhập mã vận đơn',
    'mo.confirmShip': 'Xác nhận',
    'mo.confirmComplete': 'Xác nhận hoàn thành',
    'mo.approveRefund': 'Đồng ý hoàn tiền',
    'mo.rejectRefund': 'Từ chối hoàn tiền',
    'mo.approveRefundConfirm': 'Đồng ý hoàn tiền?',
    //买家订单
    'bo.viewDetail': 'Xem chi tiết',
    'bo.orderDetail': 'Chi tiết đơn hàng',
    'bo.stepPaid': 'Đã thanh toán',
    'bo.stepShipped': 'Đã giao hàng',
    'bo.stepCompleted': 'Hoàn thành',
    'bo.refundProcessing': 'Đang xử lý hoàn tiền',
    'bo.refundApproved': 'Hoàn tiền đã duyệt',
    'bo.refundRejected': 'Hoàn tiền bị từ chối',
    'bo.productInfo': 'Thông tin sản phẩm',
    'bo.shippingInfo': 'Thông tin giao hàng',
    'bo.orderInfo': 'Thông tin đơn hàng',
    'bo.completeTime': 'Hoàn thành lúc',
    'bo.requestRefund': 'Yêu cầu hoàn tiền',
    'bo.refundReason': 'Lý do hoàn tiền',
    'bo.refundReasonPlaceholder': 'Vui lòng mô tả lý do hoàn tiền...',
    'bo.submitRefund': 'Gửi yêu cầu hoàn tiền',
    'bo.refundAlreadyRequested': 'Đã yêu cầu hoàn tiền',

    'stats.title': 'Thống kê', 'stats.todaySales': 'Doanh thu hôm nay', 'stats.weekSales': 'Doanh thu tuần', 'stats.monthSales': 'Doanh thu tháng', 'stats.totalSales': 'Tổng doanh thu', 'stats.orderCount': 'Số đơn hàng', 'stats.productCount': 'Số sản phẩm', 'stats.pendingShip': 'Chờ giao hàng', 'stats.refundPending': 'Chờ hoàn tiền', 'stats.productRanking': 'Xếp hạng sản phẩm', 'stats.sales': 'Bán', 'stats.orderNum': 'Đơn hàng', 'stats.noData': 'Chưa có dữ liệu',
    
    'app.name': '314PiMall',
    'loading': 'Đang tải...',
    'cancel': 'Hủy',
    'confirm': 'Xác nhận',
    'delete': 'Xóa',
    'edit': 'Sửa',
    'save': 'Lưu',
    'close': 'Đóng',
    'success': 'Thành công',
    'failed': 'Thất bại',
    'search': 'Tìm kiếm sản phẩm',
    'noResults': 'Không tìm thấy sản phẩm cho',
    'copy': 'Sao chép tất cả',
    'copied': 'Đã sao chép!',
    'nav.home': 'Trang chủ',
    'nav.class': 'Danh mục',
    'nav.cart': 'Giỏ hàng',
    'nav.mine': 'Cá nhân',
    'home.banner.title': '🛍️ 314PiMall Nền tảng Đa người bán',
    'home.banner.desc': 'Khám phá hàng ngàn sản phẩm từ người bán Pi đáng tin cậy',
    'home.seckill': '⚡ Flash Sale',
    'home.recommend': '🔥 Gợi ý',
    'home.more': 'Xem thêm ›',
    'home.results': 'Kết quả',
    'detail.title': 'Chi tiết sản phẩm',
    'detail.addCart': 'Thêm vào giỏ',
    'detail.buyNow': 'Mua ngay',
    'detail.description': 'Mô tả',
    'detail.sold': 'đã bán',
    'cart.title': '🛒 Giỏ hàng',
    'cart.empty': 'Giỏ hàng trống',
    'cart.emptyDesc': 'Đi mua sắm ngay!',
    'cart.total': 'Tổng:',
    'cart.checkout': 'Thanh toán',
    'cart.processing': 'Đang xử lý...',
    'cart.added': 'Đã thêm vào giỏ hàng! 🛒',
    'pay.success': 'Thanh toán thành công! 🎉',
    'pay.failed': 'Thanh toán thất bại, vui lòng thử lại',
    'pay.openPi': 'Vui lòng mở trong Pi Browser',
    'mine.user': 'Người dùng Pi',
    'mine.signIn': 'Đăng nhập để xem hồ sơ',
    'mine.signOut': 'Đăng xuất',
    'mine.pending': 'Chờ thanh toán',
    'mine.shipping': 'Đang giao',
    'mine.completed': 'Hoàn thành',
    'mine.returns': 'Trả hàng',
    'mine.orders': 'Đơn hàng',
    'mine.wallet': 'Ví Pi',
    'mine.coupons': 'Mã giảm giá',
    'mine.address': 'Địa chỉ giao hàng',
    'mine.favorites': 'Yêu thích',
    'mine.history': 'Lịch sử giao dịch',
    'mine.settings': 'Cài đặt',
    'mine.service': 'Hỗ trợ',
    'mine.noOrders': 'Chưa có đơn hàng',
    'mine.noTx': 'Chưa có giao dịch',
    'mine.walletDesc': 'Vui lòng kiểm tra Ví Pi trong Pi Browser',
    'mine.noCoupons': 'Không có mã giảm giá',
    'mine.noAddress': 'Chưa có địa chỉ',
    'mine.noFavorites': 'Chưa có yêu thích',
    'mine.comingSoon': 'Sắp ra mắt',
    'mine.orderNum': 'Đơn hàng',
    'mine.payment': 'Thanh toán',
    'order.refunded': '💸 Đã hoàn tiền',
    'order.cancelled': '❌ Đã hủy',
    'order.completed': '✅ Hoàn thành',
    'order.pending': '⏳ Chờ xử lý',
    'lang.title': 'Ngôn ngữ',
     //商家财务
    'finance.title': 'Tài chính',
    'finance.overview': 'Tổng quan thu nhập',
    'finance.totalEarnings': 'Tổng thu nhập',
    'finance.totalWithdrawn': 'Đã rút',
    'finance.balance': 'Số dư khả dụng',
    'finance.pendingSettlements': 'Chờ thanh toán',
    'finance.pendingWithdrawals': 'Chờ rút tiền',
    'finance.transactions': 'Chi tiết giao dịch',
    'finance.withdrawals': 'Lịch sử rút tiền',
    'finance.withdraw': 'Rút tiền',
    'finance.withdrawAmount': 'Số tiền rút',
    'finance.piWallet': 'Địa chỉ ví Pi',
    'finance.withdrawSubmit': 'Gửi yêu cầu rút',
    'finance.withdrawSuccess': 'Yêu cầu rút tiền đã gửi!',
    'finance.withdrawFail': 'Rút tiền thất bại',
    'finance.insufficientBalance': 'Số dư không đủ',
    'finance.noTransactions': 'Chưa có giao dịch',
    'finance.noWithdrawals': 'Chưa có lịch sử rút',
    'finance.type': 'Loại',
    'finance.amount': 'Số tiền',
    'finance.commission': 'Hoa hồng',
    'finance.netAmount': 'Thu nhập ròng',
    'finance.status': 'Trạng thái',
    'finance.time': 'Thời gian',
    'finance.settlement': 'Thanh toán',
    'finance.withdrawal': 'Rút tiền',
    'finance.pendingStatus': 'Chờ xử lý',
    'finance.completedStatus': 'Hoàn thành',
    'finance.rejectedStatus': 'Bị từ chối',

  },
};


